//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { PricingPlatformApiBase } from './PricingPlatformApiBase.base';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { DateTime, Duration } from "luxon";

export class AccountApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param searchText (optional) 
     * @return Success
     */
    search(searchText: string | undefined, cancelToken?: CancelToken | undefined): Promise<AccountDto[]> {
        let url_ = this.baseUrl + "/api/Account/Search?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<AccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAccount(body: AddAccountRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<AccountDto> {
        let url_ = this.baseUrl + "/api/Account/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: AxiosResponse): Promise<AccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountDto.fromJS(resultData200);
            return Promise.resolve<AccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccount(body: UpdateAccountRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<AccountDto> {
        let url_ = this.baseUrl + "/api/Account/UpdateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccount(_response);
        });
    }

    protected processUpdateAccount(response: AxiosResponse): Promise<AccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountDto.fromJS(resultData200);
            return Promise.resolve<AccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto>(null as any);
    }
}

export class AiApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getChatbotResponse(body: string | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Ai/GetChatbotResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChatbotResponse(_response);
        });
    }

    protected processGetChatbotResponse(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BatchQuoteApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getBatchHistory( cancelToken?: CancelToken | undefined): Promise<BatchQuoteHistoryDto[]> {
        let url_ = this.baseUrl + "/api/BatchQuote/GetBatchHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatchHistory(_response);
        });
    }

    protected processGetBatchHistory(response: AxiosResponse): Promise<BatchQuoteHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchQuoteHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BatchQuoteHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchQuoteHistoryDto[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    createBatch(file: FileParameter | undefined, cancelToken?: CancelToken | undefined): Promise<BatchQuoteHistoryDto> {
        let url_ = this.baseUrl + "/api/BatchQuote/CreateBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: AxiosResponse): Promise<BatchQuoteHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchQuoteHistoryDto.fromJS(resultData200);
            return Promise.resolve<BatchQuoteHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchQuoteHistoryDto>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    requeueBatchJob(batchId: number | undefined, cancelToken?: CancelToken | undefined): Promise<BatchQuoteHistoryDto> {
        let url_ = this.baseUrl + "/api/BatchQuote/RequeueBatchJob?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequeueBatchJob(_response);
        });
    }

    protected processRequeueBatchJob(response: AxiosResponse): Promise<BatchQuoteHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchQuoteHistoryDto.fromJS(resultData200);
            return Promise.resolve<BatchQuoteHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchQuoteHistoryDto>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    processBatch(batchId: number | undefined, cancelToken?: CancelToken | undefined): Promise<BatchQuoteHistoryDto> {
        let url_ = this.baseUrl + "/api/BatchQuote/ProcessBatch?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBatch(_response);
        });
    }

    protected processProcessBatch(response: AxiosResponse): Promise<BatchQuoteHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchQuoteHistoryDto.fromJS(resultData200);
            return Promise.resolve<BatchQuoteHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchQuoteHistoryDto>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    getBatch(batchId: number | undefined, cancelToken?: CancelToken | undefined): Promise<BatchQuoteHistoryDto> {
        let url_ = this.baseUrl + "/api/BatchQuote/GetBatch?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatch(_response);
        });
    }

    protected processGetBatch(response: AxiosResponse): Promise<BatchQuoteHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatchQuoteHistoryDto.fromJS(resultData200);
            return Promise.resolve<BatchQuoteHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatchQuoteHistoryDto>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    createErrorFile(batchId: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BatchQuote/CreateErrorFile?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateErrorFile(_response);
        });
    }

    protected processCreateErrorFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    exportBatchQuotes(batchId: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BatchQuote/ExportBatchQuotes?";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBatchQuotes(_response);
        });
    }

    protected processExportBatchQuotes(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPublicAPIErrorList( cancelToken?: CancelToken | undefined): Promise<PublicAPIErrorLogDto[]> {
        let url_ = this.baseUrl + "/api/BatchQuote/GetPublicAPIErrorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicAPIErrorList(_response);
        });
    }

    protected processGetPublicAPIErrorList(response: AxiosResponse): Promise<PublicAPIErrorLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicAPIErrorLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicAPIErrorLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicAPIErrorLogDto[]>(null as any);
    }
}

export class CommodityApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getCommodities( cancelToken?: CancelToken | undefined): Promise<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/Commodity/GetCommodities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommodities(_response);
        });
    }

    protected processGetCommodities(response: AxiosResponse): Promise<ListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommodity(body: CreateCommodityDto | undefined, cancelToken?: CancelToken | undefined): Promise<ListItemDto> {
        let url_ = this.baseUrl + "/api/Commodity/CreateCommodity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCommodity(_response);
        });
    }

    protected processCreateCommodity(response: AxiosResponse): Promise<ListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemDto.fromJS(resultData200);
            return Promise.resolve<ListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCommodity(body: UpdateCommodityDto | undefined, cancelToken?: CancelToken | undefined): Promise<ListItemDto> {
        let url_ = this.baseUrl + "/api/Commodity/UpdateCommodity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCommodity(_response);
        });
    }

    protected processUpdateCommodity(response: AxiosResponse): Promise<ListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemDto.fromJS(resultData200);
            return Promise.resolve<ListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto>(null as any);
    }

    /**
     * @param commodityId (optional) 
     * @return Success
     */
    deleteCommodity(commodityId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ListItemDto> {
        let url_ = this.baseUrl + "/api/Commodity/DeleteCommodity?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCommodity(_response);
        });
    }

    protected processDeleteCommodity(response: AxiosResponse): Promise<ListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemDto.fromJS(resultData200);
            return Promise.resolve<ListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto>(null as any);
    }
}

export class EquipmentApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getEquipmentTypes( cancelToken?: CancelToken | undefined): Promise<EquipmentTypeDto[]> {
        let url_ = this.baseUrl + "/api/Equipment/GetEquipmentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEquipmentTypes(_response);
        });
    }

    protected processGetEquipmentTypes(response: AxiosResponse): Promise<EquipmentTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EquipmentTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEquipment(body: CreateEquipmentDto | undefined, cancelToken?: CancelToken | undefined): Promise<EquipmentTypeDto> {
        let url_ = this.baseUrl + "/api/Equipment/CreateEquipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEquipment(_response);
        });
    }

    protected processCreateEquipment(response: AxiosResponse): Promise<EquipmentTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EquipmentTypeDto.fromJS(resultData200);
            return Promise.resolve<EquipmentTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEquipment(body: UpdateEquipmentDto | undefined, cancelToken?: CancelToken | undefined): Promise<EquipmentTypeDto> {
        let url_ = this.baseUrl + "/api/Equipment/UpdateEquipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEquipment(_response);
        });
    }

    protected processUpdateEquipment(response: AxiosResponse): Promise<EquipmentTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EquipmentTypeDto.fromJS(resultData200);
            return Promise.resolve<EquipmentTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentTypeDto>(null as any);
    }

    /**
     * @param equipmentId (optional) 
     * @return Success
     */
    deleteEquipment(equipmentId: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Equipment/DeleteEquipment?";
        if (equipmentId === null)
            throw new Error("The parameter 'equipmentId' cannot be null.");
        else if (equipmentId !== undefined)
            url_ += "equipmentId=" + encodeURIComponent("" + equipmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEquipment(_response);
        });
    }

    protected processDeleteEquipment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class HistoricalLoadApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestHistoricalLoadData(body: SocketHistoricalLoadRequestModel | undefined, cancelToken?: CancelToken | undefined): Promise<SocketHistoricalLoadResponseModel> {
        let url_ = this.baseUrl + "/api/HistoricalLoad/RequestHistoricalLoadData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestHistoricalLoadData(_response);
        });
    }

    protected processRequestHistoricalLoadData(response: AxiosResponse): Promise<SocketHistoricalLoadResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SocketHistoricalLoadResponseModel.fromJS(resultData200);
            return Promise.resolve<SocketHistoricalLoadResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocketHistoricalLoadResponseModel>(null as any);
    }
}

export class ImpersonationApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonationDto | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/admin/Impersonation/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonate(_response);
        });
    }

    protected processImpersonate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getImpersonationOptions( cancelToken?: CancelToken | undefined): Promise<ImpersonationOptionsDto> {
        let url_ = this.baseUrl + "/api/admin/Impersonation/GetImpersonationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImpersonationOptions(_response);
        });
    }

    protected processGetImpersonationOptions(response: AxiosResponse): Promise<ImpersonationOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonationOptionsDto.fromJS(resultData200);
            return Promise.resolve<ImpersonationOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonationOptionsDto>(null as any);
    }

    /**
     * @return Success
     */
    clearImpersonation( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/Impersonation/ClearImpersonation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearImpersonation(_response);
        });
    }

    protected processClearImpersonation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAvailablePermissions( cancelToken?: CancelToken | undefined): Promise<UserPermissionEnum[]> {
        let url_ = this.baseUrl + "/api/admin/Impersonation/GetAvailablePermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailablePermissions(_response);
        });
    }

    protected processGetAvailablePermissions(response: AxiosResponse): Promise<UserPermissionEnum[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserPermissionEnum[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPermissionEnum[]>(null as any);
    }
}

export class LocationApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    search(searchTerm: string | undefined, cancelToken?: CancelToken | undefined): Promise<CityStateLookup[]> {
        let url_ = this.baseUrl + "/api/Location/Search?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<CityStateLookup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityStateLookup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CityStateLookup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityStateLookup[]>(null as any);
    }
}

export class OfficeApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Created
     */
    create(body: AddOfficeRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<OfficeDto> {
        let url_ = this.baseUrl + "/api/Office/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = OfficeDto.fromJS(resultData201);
            return Promise.resolve<OfficeDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOfficeRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<OfficeDto> {
        let url_ = this.baseUrl + "/api/Office/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfficeDto.fromJS(resultData200);
            return Promise.resolve<OfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDto>(null as any);
    }

    /**
     * @param officeName (optional) 
     * @return Success
     */
    getOfficeByName(officeName: string | undefined, cancelToken?: CancelToken | undefined): Promise<OfficeDto> {
        let url_ = this.baseUrl + "/api/Office/GetOfficeByName?";
        if (officeName === null)
            throw new Error("The parameter 'officeName' cannot be null.");
        else if (officeName !== undefined)
            url_ += "officeName=" + encodeURIComponent("" + officeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfficeByName(_response);
        });
    }

    protected processGetOfficeByName(response: AxiosResponse): Promise<OfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfficeDto.fromJS(resultData200);
            return Promise.resolve<OfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDto>(null as any);
    }

    /**
     * @param officeId (optional) 
     * @return Success
     */
    getOfficeById(officeId: number | undefined, cancelToken?: CancelToken | undefined): Promise<OfficeDto> {
        let url_ = this.baseUrl + "/api/Office/GetOfficeById?";
        if (officeId === null)
            throw new Error("The parameter 'officeId' cannot be null.");
        else if (officeId !== undefined)
            url_ += "officeId=" + encodeURIComponent("" + officeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfficeById(_response);
        });
    }

    protected processGetOfficeById(response: AxiosResponse): Promise<OfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfficeDto.fromJS(resultData200);
            return Promise.resolve<OfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDto>(null as any);
    }

    /**
     * @return Success
     */
    getOfficeList( cancelToken?: CancelToken | undefined): Promise<OfficeDto[]> {
        let url_ = this.baseUrl + "/api/Office/GetOfficeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfficeList(_response);
        });
    }

    protected processGetOfficeList(response: AxiosResponse): Promise<OfficeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OfficeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfficeDto[]>(null as any);
    }
}

export class PricingParametersApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getPricingRegions( cancelToken?: CancelToken | undefined): Promise<PricingRegionDto[]> {
        let url_ = this.baseUrl + "/api/PricingParameters/GetPricingRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPricingRegions(_response);
        });
    }

    protected processGetPricingRegions(response: AxiosResponse): Promise<PricingRegionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PricingRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PricingRegionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingRegionDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPricingParameters( cancelToken?: CancelToken | undefined): Promise<PricingParametersDto> {
        let url_ = this.baseUrl + "/api/PricingParameters/GetPricingParameters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPricingParameters(_response);
        });
    }

    protected processGetPricingParameters(response: AxiosResponse): Promise<PricingParametersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PricingParametersDto.fromJS(resultData200);
            return Promise.resolve<PricingParametersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingParametersDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param markup (optional) 
     * @return Success
     */
    editMinimumMarkup(id: number | undefined, markup: number | undefined, cancelToken?: CancelToken | undefined): Promise<PricingRegionDto> {
        let url_ = this.baseUrl + "/api/PricingParameters/EditMinimumMarkup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (markup === null)
            throw new Error("The parameter 'markup' cannot be null.");
        else if (markup !== undefined)
            url_ += "markup=" + encodeURIComponent("" + markup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditMinimumMarkup(_response);
        });
    }

    protected processEditMinimumMarkup(response: AxiosResponse): Promise<PricingRegionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PricingRegionDto.fromJS(resultData200);
            return Promise.resolve<PricingRegionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingRegionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePricingParameters(body: PricingParameterValueDto[] | undefined, cancelToken?: CancelToken | undefined): Promise<PricingParameterValueDto[]> {
        let url_ = this.baseUrl + "/api/PricingParameters/UpdatePricingParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePricingParameters(_response);
        });
    }

    protected processUpdatePricingParameters(response: AxiosResponse): Promise<PricingParameterValueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PricingParameterValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PricingParameterValueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingParameterValueDto[]>(null as any);
    }
}

export class QuoteApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param hashedId (optional) 
     * @return Success
     */
    getQuoteDetails(hashedId: string | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/Quote/GetQuoteDetails?";
        if (hashedId === null)
            throw new Error("The parameter 'hashedId' cannot be null.");
        else if (hashedId !== undefined)
            url_ += "hashedId=" + encodeURIComponent("" + hashedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteDetails(_response);
        });
    }

    protected processGetQuoteDetails(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @param hashedId (optional) 
     * @return Success
     */
    getPublicQuoteDetails(hashedId: string | undefined, cancelToken?: CancelToken | undefined): Promise<PublicQuoteDto> {
        let url_ = this.baseUrl + "/api/Quote/GetPublicQuoteDetails?";
        if (hashedId === null)
            throw new Error("The parameter 'hashedId' cannot be null.");
        else if (hashedId !== undefined)
            url_ += "hashedId=" + encodeURIComponent("" + hashedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicQuoteDetails(_response);
        });
    }

    protected processGetPublicQuoteDetails(response: AxiosResponse): Promise<PublicQuoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicQuoteDto.fromJS(resultData200);
            return Promise.resolve<PublicQuoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicQuoteDto>(null as any);
    }

    /**
     * @param quoteId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTargetSellRate(quoteId: number | undefined, body: QuoteTargetSellRateDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteTargetSellRateDto> {
        let url_ = this.baseUrl + "/api/Quote/UpdateTargetSellRate?";
        if (quoteId === null)
            throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined)
            url_ += "quoteId=" + encodeURIComponent("" + quoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTargetSellRate(_response);
        });
    }

    protected processUpdateTargetSellRate(response: AxiosResponse): Promise<QuoteTargetSellRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteTargetSellRateDto.fromJS(resultData200);
            return Promise.resolve<QuoteTargetSellRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteTargetSellRateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    overridePricing(body: OverridePricingRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/Quote/OverridePricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverridePricing(_response);
        });
    }

    protected processOverridePricing(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPricingOverride(body: OverridePricingRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/Quote/ResetPricingOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPricingOverride(_response);
        });
    }

    protected processResetPricingOverride(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    similarQuotes(body: SimilarQuoteRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteHistoryDto[]> {
        let url_ = this.baseUrl + "/api/Quote/SimilarQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimilarQuotes(_response);
        });
    }

    protected processSimilarQuotes(response: AxiosResponse): Promise<QuoteHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuoteHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteHistoryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePricing(body: PricingUpdate | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/Quote/ChangePricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePricing(_response);
        });
    }

    protected processChangePricing(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @param hashedQuoteId (optional) 
     * @param range (optional) 
     * @return Success
     */
    getLaneInsights(hashedQuoteId: string | undefined, range: number | undefined, cancelToken?: CancelToken | undefined): Promise<LaneInsightsDto> {
        let url_ = this.baseUrl + "/api/Quote/GetLaneInsights?";
        if (hashedQuoteId === null)
            throw new Error("The parameter 'hashedQuoteId' cannot be null.");
        else if (hashedQuoteId !== undefined)
            url_ += "hashedQuoteId=" + encodeURIComponent("" + hashedQuoteId) + "&";
        if (range === null)
            throw new Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLaneInsights(_response);
        });
    }

    protected processGetLaneInsights(response: AxiosResponse): Promise<LaneInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LaneInsightsDto.fromJS(resultData200);
            return Promise.resolve<LaneInsightsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaneInsightsDto>(null as any);
    }

    /**
     * @param hashedQuoteId (optional) 
     * @param range (optional) 
     * @return Success
     */
    getCustomerInsights(hashedQuoteId: string | undefined, range: number | undefined, cancelToken?: CancelToken | undefined): Promise<CustomerInsightsDto> {
        let url_ = this.baseUrl + "/api/Quote/GetCustomerInsights?";
        if (hashedQuoteId === null)
            throw new Error("The parameter 'hashedQuoteId' cannot be null.");
        else if (hashedQuoteId !== undefined)
            url_ += "hashedQuoteId=" + encodeURIComponent("" + hashedQuoteId) + "&";
        if (range === null)
            throw new Error("The parameter 'range' cannot be null.");
        else if (range !== undefined)
            url_ += "range=" + encodeURIComponent("" + range) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerInsights(_response);
        });
    }

    protected processGetCustomerInsights(response: AxiosResponse): Promise<CustomerInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerInsightsDto.fromJS(resultData200);
            return Promise.resolve<CustomerInsightsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInsightsDto>(null as any);
    }

    /**
     * @param hashedQuoteId (optional) 
     * @return Success
     */
    getListInsights(hashedQuoteId: string | undefined, cancelToken?: CancelToken | undefined): Promise<SimilarListInsightsDto> {
        let url_ = this.baseUrl + "/api/Quote/GetListInsights?";
        if (hashedQuoteId === null)
            throw new Error("The parameter 'hashedQuoteId' cannot be null.");
        else if (hashedQuoteId !== undefined)
            url_ += "hashedQuoteId=" + encodeURIComponent("" + hashedQuoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListInsights(_response);
        });
    }

    protected processGetListInsights(response: AxiosResponse): Promise<SimilarListInsightsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimilarListInsightsDto.fromJS(resultData200);
            return Promise.resolve<SimilarListInsightsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimilarListInsightsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshStopsPricingRegions(body: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Quote/RefreshStopsPricingRegions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshStopsPricingRegions(_response);
        });
    }

    protected processRefreshStopsPricingRegions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuoteHistoryApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getQuoteHistory(body: QuoteHistoryFilterOptions | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteHistoryDto[]> {
        let url_ = this.baseUrl + "/api/QuoteHistory/GetQuoteHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteHistory(_response);
        });
    }

    protected processGetQuoteHistory(response: AxiosResponse): Promise<QuoteHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuoteHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteHistoryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportQuotes(body: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/QuoteHistory/ExportQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportQuotes(_response);
        });
    }

    protected processExportQuotes(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RequestQuoteApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getRequestQuoteOptions( cancelToken?: CancelToken | undefined): Promise<RequestQuoteOptionsDto> {
        let url_ = this.baseUrl + "/api/RequestQuote/GetRequestQuoteOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestQuoteOptions(_response);
        });
    }

    protected processGetRequestQuoteOptions(response: AxiosResponse): Promise<RequestQuoteOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestQuoteOptionsDto.fromJS(resultData200);
            return Promise.resolve<RequestQuoteOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestQuoteOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestQuote(body: QuoteRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/RequestQuote/RequestQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestQuote(_response);
        });
    }

    protected processRequestQuote(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    getQuoteHistory( cancelToken?: CancelToken | undefined): Promise<QuoteHistoryDto[]> {
        let url_ = this.baseUrl + "/api/RequestQuote/GetQuoteHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteHistory(_response);
        });
    }

    protected processGetQuoteHistory(response: AxiosResponse): Promise<QuoteHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuoteHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteHistoryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQuoteStatus(body: UpdateQuoteStatusRequest | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/RequestQuote/UpdateQuoteStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuoteStatus(_response);
        });
    }

    protected processUpdateQuoteStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQuote(body: UpdateQuoteStatusDetailsDto | undefined, cancelToken?: CancelToken | undefined): Promise<QuoteResponseDto> {
        let url_ = this.baseUrl + "/api/RequestQuote/UpdateQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuote(_response);
        });
    }

    protected processUpdateQuote(response: AxiosResponse): Promise<QuoteResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuoteResponseDto.fromJS(resultData200);
            return Promise.resolve<QuoteResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportQuotes(body: string[] | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RequestQuote/ExportQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportQuotes(_response);
        });
    }

    protected processExportQuotes(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SettingApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getBusinessHours( cancelToken?: CancelToken | undefined): Promise<SettingDto[]> {
        let url_ = this.baseUrl + "/api/Setting/GetBusinessHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessHours(_response);
        });
    }

    protected processGetBusinessHours(response: AxiosResponse): Promise<SettingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SettingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSetting(body: UpdateSettingDto[] | undefined, cancelToken?: CancelToken | undefined): Promise<SettingDto[]> {
        let url_ = this.baseUrl + "/api/Setting/UpdateSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSetting(_response);
        });
    }

    protected processUpdateSetting(response: AxiosResponse): Promise<SettingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SettingDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingDto[]>(null as any);
    }
}

export class SpecializedServiceApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getSpecializedServices( cancelToken?: CancelToken | undefined): Promise<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/SpecializedService/GetSpecializedServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecializedServices(_response);
        });
    }

    protected processGetSpecializedServices(response: AxiosResponse): Promise<ListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto[]>(null as any);
    }

    /**
     * Creates a specialized service.
     * @param body (optional) The request object containing the details of the specialized service.
     * @return Success
     */
    createSpecializedService(body: CreateSpecializedServiceDto | undefined, cancelToken?: CancelToken | undefined): Promise<ListItemDto> {
        let url_ = this.baseUrl + "/api/SpecializedService/CreateSpecializedService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSpecializedService(_response);
        });
    }

    protected processCreateSpecializedService(response: AxiosResponse): Promise<ListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemDto.fromJS(resultData200);
            return Promise.resolve<ListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto>(null as any);
    }

    /**
     * Updates a specialized service.
     * @param body (optional) The request object containing the details of the specialized service to be updated.
     * @return Success
     */
    updateSpecializedService(body: UpdateSpecializedServiceDto | undefined, cancelToken?: CancelToken | undefined): Promise<ListItemDto> {
        let url_ = this.baseUrl + "/api/SpecializedService/UpdateSpecializedService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSpecializedService(_response);
        });
    }

    protected processUpdateSpecializedService(response: AxiosResponse): Promise<ListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListItemDto.fromJS(resultData200);
            return Promise.resolve<ListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDto>(null as any);
    }

    /**
     * @param specializedServiceId (optional) 
     * @return Success
     */
    deleteSpecializedService(specializedServiceId: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SpecializedService/DeleteSpecializedService?";
        if (specializedServiceId === null)
            throw new Error("The parameter 'specializedServiceId' cannot be null.");
        else if (specializedServiceId !== undefined)
            url_ += "specializedServiceId=" + encodeURIComponent("" + specializedServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSpecializedService(_response);
        });
    }

    protected processDeleteSpecializedService(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class TenantManagementApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getCurrentTenant( cancelToken?: CancelToken | undefined): Promise<TenantDto[]> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/GetCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTenant(_response);
        });
    }

    protected processGetCurrentTenant(response: AxiosResponse): Promise<TenantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTenants( cancelToken?: CancelToken | undefined): Promise<TenantDto[]> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/GetTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<TenantDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantDto | undefined, cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return Promise.resolve<TenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    setTenantSettings(tenantId: number | undefined, body: { [key: string]: string; } | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/SetTenantSettings?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTenantSettings(_response);
        });
    }

    protected processSetTenantSettings(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantSettings(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/GetTenantSettings?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantSettings(_response);
        });
    }

    protected processGetTenantSettings(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return Success
     */
    seedTenantData( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/TenantManagement/SeedTenantData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeedTenantData(_response);
        });
    }

    protected processSeedTenantData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TestApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getUtcNow( cancelToken?: CancelToken | undefined): Promise<DateTime[]> {
        let url_ = this.baseUrl + "/api/Test/GetUtcNow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUtcNow(_response);
        });
    }

    protected processGetUtcNow(response: AxiosResponse): Promise<DateTime[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateTime.fromISO(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DateTime[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTime[]>(null as any);
    }

    /**
     * @return Success
     */
    getSocketResponseModel( cancelToken?: CancelToken | undefined): Promise<SocketResponseModel> {
        let url_ = this.baseUrl + "/api/Test/GetSocketResponseModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSocketResponseModel(_response);
        });
    }

    protected processGetSocketResponseModel(response: AxiosResponse): Promise<SocketResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SocketResponseModel.fromJS(resultData200);
            return Promise.resolve<SocketResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocketResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateLeadTime(body: CalculateLeadTimeRequest | undefined, cancelToken?: CancelToken | undefined): Promise<CalculateLeadTimeResponseModel> {
        let url_ = this.baseUrl + "/api/Test/CalculateLeadTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateLeadTime(_response);
        });
    }

    protected processCalculateLeadTime(response: AxiosResponse): Promise<CalculateLeadTimeResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateLeadTimeResponseModel.fromJS(resultData200);
            return Promise.resolve<CalculateLeadTimeResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateLeadTimeResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getEnv( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Test/GetEnv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnv(_response);
        });
    }

    protected processGetEnv(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserApi extends PricingPlatformApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Created
     */
    create(body: AddUserRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UserDto.fromJS(resultData201);
            return Promise.resolve<UserDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePublicApiUser(body: UpdateApiUserRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/UpdatePublicApiUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePublicApiUser(_response);
        });
    }

    protected processUpdatePublicApiUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUser( cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserByEmail(email: string, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserByEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByEmail(_response);
        });
    }

    protected processGetUserByEmail(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/GetUserById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserRoles( cancelToken?: CancelToken | undefined): Promise<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/User/GetUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoles(_response);
        });
    }

    protected processGetUserRoles(response: AxiosResponse): Promise<UserRoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserRoleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRoleDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllUsers( cancelToken?: CancelToken | undefined): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    deleteUser(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/DeleteUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getUserOptions( cancelToken?: CancelToken | undefined): Promise<RequestQuoteOptionsDto> {
        let url_ = this.baseUrl + "/api/User/GetUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOptions(_response);
        });
    }

    protected processGetUserOptions(response: AxiosResponse): Promise<RequestQuoteOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestQuoteOptionsDto.fromJS(resultData200);
            return Promise.resolve<RequestQuoteOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestQuoteOptionsDto>(null as any);
    }
}

export class AccountDto implements IAccountDto {
    id?: number;
    offices?: OfficeDto[] | undefined;
    name?: string | undefined;
    externalAccountId?: number | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["offices"])) {
                this.offices = [] as any;
                for (let item of _data["offices"])
                    this.offices!.push(OfficeDto.fromJS(item));
            }
            this.name = _data["name"];
            this.externalAccountId = _data["externalAccountId"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (let item of this.offices)
                data["offices"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["externalAccountId"] = this.externalAccountId;
        return data;
    }
}

export interface IAccountDto {
    id?: number;
    offices?: OfficeDto[] | undefined;
    name?: string | undefined;
    externalAccountId?: number | undefined;
}

export class AddAccountRequestDto implements IAddAccountRequestDto {
    officeId?: number | undefined;
    name?: string | undefined;

    constructor(data?: IAddAccountRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeId = _data["officeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddAccountRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeId"] = this.officeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAddAccountRequestDto {
    officeId?: number | undefined;
    name?: string | undefined;
}

export class AddOfficeRequestDto implements IAddOfficeRequestDto {
    name!: string;
    accountIds?: number[] | undefined;

    constructor(data?: IAddOfficeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddOfficeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOfficeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        return data;
    }
}

export interface IAddOfficeRequestDto {
    name: string;
    accountIds?: number[] | undefined;
}

export class AddUserRequestDto implements IAddUserRequestDto {
    auth0Id?: string | undefined;
    email!: string;
    userRoleId!: number;
    firstName!: string;
    lastName!: string;
    isAdmin?: boolean;
    officeId?: number | undefined;
    accountId?: number | undefined;

    constructor(data?: IAddUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auth0Id = _data["auth0Id"];
            this.email = _data["email"];
            this.userRoleId = _data["userRoleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAdmin = _data["isAdmin"];
            this.officeId = _data["officeId"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AddUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth0Id"] = this.auth0Id;
        data["email"] = this.email;
        data["userRoleId"] = this.userRoleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAdmin"] = this.isAdmin;
        data["officeId"] = this.officeId;
        data["accountId"] = this.accountId;
        return data;
    }
}

export interface IAddUserRequestDto {
    auth0Id?: string | undefined;
    email: string;
    userRoleId: number;
    firstName: string;
    lastName: string;
    isAdmin?: boolean;
    officeId?: number | undefined;
    accountId?: number | undefined;
}

export class Address implements IAddress {
    country?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IAddress {
    country?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export class BatchQuoteHistoryDto implements IBatchQuoteHistoryDto {
    batchID?: number;
    fileName?: string | undefined;
    numberOfQuotesIncluded?: number | undefined;
    status?: string | undefined;
    createdBy?: UserDto;
    createdOnUtc?: DateTime;
    numberOfErrorQuotes?: number | undefined;
    errorFile?: string | undefined;
    uploadedFile?: string | undefined;
    officeId?: number | undefined;

    constructor(data?: IBatchQuoteHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchID = _data["batchID"];
            this.fileName = _data["fileName"];
            this.numberOfQuotesIncluded = _data["numberOfQuotesIncluded"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>undefined;
            this.numberOfErrorQuotes = _data["numberOfErrorQuotes"];
            this.errorFile = _data["errorFile"];
            this.uploadedFile = _data["uploadedFile"];
            this.officeId = _data["officeId"];
        }
    }

    static fromJS(data: any): BatchQuoteHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchQuoteHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchID"] = this.batchID;
        data["fileName"] = this.fileName;
        data["numberOfQuotesIncluded"] = this.numberOfQuotesIncluded;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>undefined;
        data["numberOfErrorQuotes"] = this.numberOfErrorQuotes;
        data["errorFile"] = this.errorFile;
        data["uploadedFile"] = this.uploadedFile;
        data["officeId"] = this.officeId;
        return data;
    }
}

export interface IBatchQuoteHistoryDto {
    batchID?: number;
    fileName?: string | undefined;
    numberOfQuotesIncluded?: number | undefined;
    status?: string | undefined;
    createdBy?: UserDto;
    createdOnUtc?: DateTime;
    numberOfErrorQuotes?: number | undefined;
    errorFile?: string | undefined;
    uploadedFile?: string | undefined;
    officeId?: number | undefined;
}

export class CalculateLeadTimeRequest implements ICalculateLeadTimeRequest {
    pickupDate?: string | undefined;
    pickupHour?: number | undefined;
    pickupMinute?: number | undefined;

    constructor(data?: ICalculateLeadTimeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickupDate = _data["pickupDate"];
            this.pickupHour = _data["pickupHour"];
            this.pickupMinute = _data["pickupMinute"];
        }
    }

    static fromJS(data: any): CalculateLeadTimeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateLeadTimeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickupDate"] = this.pickupDate;
        data["pickupHour"] = this.pickupHour;
        data["pickupMinute"] = this.pickupMinute;
        return data;
    }
}

export interface ICalculateLeadTimeRequest {
    pickupDate?: string | undefined;
    pickupHour?: number | undefined;
    pickupMinute?: number | undefined;
}

export class CalculateLeadTimeResponseModel implements ICalculateLeadTimeResponseModel {
    quoteSubmissionUtcDate?: DateTime;
    nonBusinessHours?: number;
    totalHours?: number;
    leadTimeRaw?: number;
    readonly leadTimeHours?: number;
    pickupDateOnly?: DateTime | undefined;
    pickupTime?: TimeSpan;
    endDateTimeUtc?: DateTime | undefined;

    constructor(data?: ICalculateLeadTimeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteSubmissionUtcDate = _data["quoteSubmissionUtcDate"] ? DateTime.fromISO(_data["quoteSubmissionUtcDate"].toString()) : <any>undefined;
            this.nonBusinessHours = _data["nonBusinessHours"];
            this.totalHours = _data["totalHours"];
            this.leadTimeRaw = _data["leadTimeRaw"];
            (<any>this).leadTimeHours = _data["leadTimeHours"];
            this.pickupDateOnly = _data["pickupDateOnly"] ? DateTime.fromISO(_data["pickupDateOnly"].toString()) : <any>undefined;
            this.pickupTime = _data["pickupTime"] ? TimeSpan.fromJS(_data["pickupTime"]) : <any>undefined;
            this.endDateTimeUtc = _data["endDateTimeUtc"] ? DateTime.fromISO(_data["endDateTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CalculateLeadTimeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateLeadTimeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteSubmissionUtcDate"] = this.quoteSubmissionUtcDate ? this.quoteSubmissionUtcDate.toString() : <any>undefined;
        data["nonBusinessHours"] = this.nonBusinessHours;
        data["totalHours"] = this.totalHours;
        data["leadTimeRaw"] = this.leadTimeRaw;
        data["leadTimeHours"] = this.leadTimeHours;
        data["pickupDateOnly"] = this.pickupDateOnly ? this.pickupDateOnly.toString() : <any>undefined;
        data["pickupTime"] = this.pickupTime ? this.pickupTime.toJSON() : <any>undefined;
        data["endDateTimeUtc"] = this.endDateTimeUtc ? this.endDateTimeUtc.toString() : <any>undefined;
        return data;
    }
}

export interface ICalculateLeadTimeResponseModel {
    quoteSubmissionUtcDate?: DateTime;
    nonBusinessHours?: number;
    totalHours?: number;
    leadTimeRaw?: number;
    leadTimeHours?: number;
    pickupDateOnly?: DateTime | undefined;
    pickupTime?: TimeSpan;
    endDateTimeUtc?: DateTime | undefined;
}

export class CarrierInfoDto implements ICarrierInfoDto {
    name?: string | undefined;
    numberLoads?: number;
    averageBuyRate?: number;

    constructor(data?: ICarrierInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.numberLoads = _data["numberLoads"];
            this.averageBuyRate = _data["averageBuyRate"];
        }
    }

    static fromJS(data: any): CarrierInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["numberLoads"] = this.numberLoads;
        data["averageBuyRate"] = this.averageBuyRate;
        return data;
    }
}

export interface ICarrierInfoDto {
    name?: string | undefined;
    numberLoads?: number;
    averageBuyRate?: number;
}

export class CarrierRepInfoDto implements ICarrierRepInfoDto {
    name?: string | undefined;
    numberLoads?: number;
    averageBuyRate?: number;

    constructor(data?: ICarrierRepInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.numberLoads = _data["numberLoads"];
            this.averageBuyRate = _data["averageBuyRate"];
        }
    }

    static fromJS(data: any): CarrierRepInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierRepInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["numberLoads"] = this.numberLoads;
        data["averageBuyRate"] = this.averageBuyRate;
        return data;
    }
}

export interface ICarrierRepInfoDto {
    name?: string | undefined;
    numberLoads?: number;
    averageBuyRate?: number;
}

export class CityStateLookup implements ICityStateLookup {
    zipcode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateName?: string | undefined;
    locationType?: string | undefined;
    lat?: string | undefined;
    long?: string | undefined;
    country?: string | undefined;

    constructor(data?: ICityStateLookup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zipcode = _data["zipcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.locationType = _data["locationType"];
            this.lat = _data["lat"];
            this.long = _data["long"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CityStateLookup {
        data = typeof data === 'object' ? data : {};
        let result = new CityStateLookup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipcode"] = this.zipcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["locationType"] = this.locationType;
        data["lat"] = this.lat;
        data["long"] = this.long;
        data["country"] = this.country;
        return data;
    }
}

export interface ICityStateLookup {
    zipcode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateName?: string | undefined;
    locationType?: string | undefined;
    lat?: string | undefined;
    long?: string | undefined;
    country?: string | undefined;
}

export class CompanyNetworkRate implements ICompanyNetworkRate {
    id?: string | undefined;
    targetBuyRate?: number;
    lowBuyRate?: number;
    highBuyRate?: number;
    startBuyRate?: number;
    fuelRate?: number;
    distance?: number;
    confidenceLevel?: number;
    acceptanceRates?: any[] | undefined;
    tag?: string | undefined;
    currency?: string | undefined;

    constructor(data?: ICompanyNetworkRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetBuyRate = _data["targetBuyRate"];
            this.lowBuyRate = _data["lowBuyRate"];
            this.highBuyRate = _data["highBuyRate"];
            this.startBuyRate = _data["startBuyRate"];
            this.fuelRate = _data["fuelRate"];
            this.distance = _data["distance"];
            this.confidenceLevel = _data["confidenceLevel"];
            if (Array.isArray(_data["acceptanceRates"])) {
                this.acceptanceRates = [] as any;
                for (let item of _data["acceptanceRates"])
                    this.acceptanceRates!.push(item);
            }
            this.tag = _data["tag"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CompanyNetworkRate {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyNetworkRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetBuyRate"] = this.targetBuyRate;
        data["lowBuyRate"] = this.lowBuyRate;
        data["highBuyRate"] = this.highBuyRate;
        data["startBuyRate"] = this.startBuyRate;
        data["fuelRate"] = this.fuelRate;
        data["distance"] = this.distance;
        data["confidenceLevel"] = this.confidenceLevel;
        if (Array.isArray(this.acceptanceRates)) {
            data["acceptanceRates"] = [];
            for (let item of this.acceptanceRates)
                data["acceptanceRates"].push(item);
        }
        data["tag"] = this.tag;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICompanyNetworkRate {
    id?: string | undefined;
    targetBuyRate?: number;
    lowBuyRate?: number;
    highBuyRate?: number;
    startBuyRate?: number;
    fuelRate?: number;
    distance?: number;
    confidenceLevel?: number;
    acceptanceRates?: any[] | undefined;
    tag?: string | undefined;
    currency?: string | undefined;
}

export class CreateCommodityDto implements ICreateCommodityDto {
    name?: string | undefined;

    constructor(data?: ICreateCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCommodityDto {
    name?: string | undefined;
}

export class CreateEquipmentDto implements ICreateEquipmentDto {
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;

    constructor(data?: ICreateEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.hasTemperatureOption = _data["hasTemperatureOption"];
            this.hasTarpOption = _data["hasTarpOption"];
            this.hasOversizedOption = _data["hasOversizedOption"];
        }
    }

    static fromJS(data: any): CreateEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hasTemperatureOption"] = this.hasTemperatureOption;
        data["hasTarpOption"] = this.hasTarpOption;
        data["hasOversizedOption"] = this.hasOversizedOption;
        return data;
    }
}

export interface ICreateEquipmentDto {
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;
}

export class CreateSpecializedServiceDto implements ICreateSpecializedServiceDto {
    name?: string | undefined;

    constructor(data?: ICreateSpecializedServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSpecializedServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecializedServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateSpecializedServiceDto {
    name?: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    name?: string | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTenantDto {
    name?: string | undefined;
}

export class CustomerInsightsDto implements ICustomerInsightsDto {
    quoteId?: number;
    customerName?: string | undefined;
    range?: number;
    countQuotesTotal?: number;
    countQuotesWithDate?: number;
    countQuotesWithoutDate?: number;
    countPendingQuotes?: number;
    countWonQuotes?: number;
    countLostQuotes?: number;
    readonly winPercentage?: number | undefined;

    constructor(data?: ICustomerInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.customerName = _data["customerName"];
            this.range = _data["range"];
            this.countQuotesTotal = _data["countQuotesTotal"];
            this.countQuotesWithDate = _data["countQuotesWithDate"];
            this.countQuotesWithoutDate = _data["countQuotesWithoutDate"];
            this.countPendingQuotes = _data["countPendingQuotes"];
            this.countWonQuotes = _data["countWonQuotes"];
            this.countLostQuotes = _data["countLostQuotes"];
            (<any>this).winPercentage = _data["winPercentage"];
        }
    }

    static fromJS(data: any): CustomerInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["customerName"] = this.customerName;
        data["range"] = this.range;
        data["countQuotesTotal"] = this.countQuotesTotal;
        data["countQuotesWithDate"] = this.countQuotesWithDate;
        data["countQuotesWithoutDate"] = this.countQuotesWithoutDate;
        data["countPendingQuotes"] = this.countPendingQuotes;
        data["countWonQuotes"] = this.countWonQuotes;
        data["countLostQuotes"] = this.countLostQuotes;
        data["winPercentage"] = this.winPercentage;
        return data;
    }
}

export interface ICustomerInsightsDto {
    quoteId?: number;
    customerName?: string | undefined;
    range?: number;
    countQuotesTotal?: number;
    countQuotesWithDate?: number;
    countQuotesWithoutDate?: number;
    countPendingQuotes?: number;
    countWonQuotes?: number;
    countLostQuotes?: number;
    winPercentage?: number | undefined;
}

export class DatAddressModel implements IDatAddressModel {
    city?: string | undefined;
    stateOrProvince?: string | undefined;

    constructor(data?: IDatAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.stateOrProvince = _data["stateOrProvince"];
        }
    }

    static fromJS(data: any): DatAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new DatAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["stateOrProvince"] = this.stateOrProvince;
        return data;
    }
}

export interface IDatAddressModel {
    city?: string | undefined;
    stateOrProvince?: string | undefined;
}

export class DatProjectedCost implements IDatProjectedCost {
    mileage?: number;
    predictedRate?: number;
    lowRate?: number;
    highRate?: number;
    reportsCount?: number;
    companiesCount?: number;
    origin?: string | undefined;
    destination?: string | undefined;
    loadToTruckRatio?: string | undefined;
    days?: string | undefined;
    geoCode?: string | undefined;
    fuelRate?: number;
    escalationType?: string | undefined;
    specificTimeFrame?: string | undefined;

    constructor(data?: IDatProjectedCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mileage = _data["mileage"];
            this.predictedRate = _data["predictedRate"];
            this.lowRate = _data["lowRate"];
            this.highRate = _data["highRate"];
            this.reportsCount = _data["reportsCount"];
            this.companiesCount = _data["companiesCount"];
            this.origin = _data["origin"];
            this.destination = _data["destination"];
            this.loadToTruckRatio = _data["loadToTruckRatio"];
            this.days = _data["days"];
            this.geoCode = _data["geoCode"];
            this.fuelRate = _data["fuelRate"];
            this.escalationType = _data["escalationType"];
            this.specificTimeFrame = _data["specificTimeFrame"];
        }
    }

    static fromJS(data: any): DatProjectedCost {
        data = typeof data === 'object' ? data : {};
        let result = new DatProjectedCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mileage"] = this.mileage;
        data["predictedRate"] = this.predictedRate;
        data["lowRate"] = this.lowRate;
        data["highRate"] = this.highRate;
        data["reportsCount"] = this.reportsCount;
        data["companiesCount"] = this.companiesCount;
        data["origin"] = this.origin;
        data["destination"] = this.destination;
        data["loadToTruckRatio"] = this.loadToTruckRatio;
        data["days"] = this.days;
        data["geoCode"] = this.geoCode;
        data["fuelRate"] = this.fuelRate;
        data["escalationType"] = this.escalationType;
        data["specificTimeFrame"] = this.specificTimeFrame;
        return data;
    }
}

export interface IDatProjectedCost {
    mileage?: number;
    predictedRate?: number;
    lowRate?: number;
    highRate?: number;
    reportsCount?: number;
    companiesCount?: number;
    origin?: string | undefined;
    destination?: string | undefined;
    loadToTruckRatio?: string | undefined;
    days?: string | undefined;
    geoCode?: string | undefined;
    fuelRate?: number;
    escalationType?: string | undefined;
    specificTimeFrame?: string | undefined;
}

export class DatRateResponse implements IDatRateResponse {
    rate?: Rate;
    escalation?: Escalation;

    constructor(data?: IDatRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] ? Rate.fromJS(_data["rate"]) : <any>undefined;
            this.escalation = _data["escalation"] ? Escalation.fromJS(_data["escalation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        data["escalation"] = this.escalation ? this.escalation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatRateResponse {
    rate?: Rate;
    escalation?: Escalation;
}

export class EquipmentTypeDto implements IEquipmentTypeDto {
    id?: number;
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;

    constructor(data?: IEquipmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hasTemperatureOption = _data["hasTemperatureOption"];
            this.hasTarpOption = _data["hasTarpOption"];
            this.hasOversizedOption = _data["hasOversizedOption"];
        }
    }

    static fromJS(data: any): EquipmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hasTemperatureOption"] = this.hasTemperatureOption;
        data["hasTarpOption"] = this.hasTarpOption;
        data["hasOversizedOption"] = this.hasOversizedOption;
        return data;
    }
}

export interface IEquipmentTypeDto {
    id?: number;
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;
}

export class ErrorMessage implements IErrorMessage {
    message?: string | undefined;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorMessage {
    message?: string | undefined;
}

export class Escalation implements IEscalation {
    timeframe?: string | undefined;
    origin?: OriginDestination;
    destination?: OriginDestination;

    constructor(data?: IEscalation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeframe = _data["timeframe"];
            this.origin = _data["origin"] ? OriginDestination.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? OriginDestination.fromJS(_data["destination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Escalation {
        data = typeof data === 'object' ? data : {};
        let result = new Escalation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeframe"] = this.timeframe;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEscalation {
    timeframe?: string | undefined;
    origin?: OriginDestination;
    destination?: OriginDestination;
}

export class ExtraStop implements IExtraStop {
    order?: number;
    address?: Address;

    constructor(data?: IExtraStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtraStop {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtraStop {
    order?: number;
    address?: Address;
}

export class GreenScreensProjectedCostDto implements IGreenScreensProjectedCostDto {
    targetBuyRate?: number;
    confidenceLevel?: number;
    lowBuyRate?: number;
    highBuyRate?: number;
    fuelRate?: number;
    mileage?: number;
    source?: string | undefined;

    constructor(data?: IGreenScreensProjectedCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetBuyRate = _data["targetBuyRate"];
            this.confidenceLevel = _data["confidenceLevel"];
            this.lowBuyRate = _data["lowBuyRate"];
            this.highBuyRate = _data["highBuyRate"];
            this.fuelRate = _data["fuelRate"];
            this.mileage = _data["mileage"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): GreenScreensProjectedCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenScreensProjectedCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetBuyRate"] = this.targetBuyRate;
        data["confidenceLevel"] = this.confidenceLevel;
        data["lowBuyRate"] = this.lowBuyRate;
        data["highBuyRate"] = this.highBuyRate;
        data["fuelRate"] = this.fuelRate;
        data["mileage"] = this.mileage;
        data["source"] = this.source;
        return data;
    }
}

export interface IGreenScreensProjectedCostDto {
    targetBuyRate?: number;
    confidenceLevel?: number;
    lowBuyRate?: number;
    highBuyRate?: number;
    fuelRate?: number;
    mileage?: number;
    source?: string | undefined;
}

export class GreenscreensDataLakeItem implements IGreenscreensDataLakeItem {
    totalCarrierCost?: number | undefined;
    totalCarrierRate?: number | undefined;
    loadPickupDate?: string | undefined;
    pickupDateTime?: DateTime | undefined;
    deliveredDateTime?: DateTime | undefined;
    transportTypeTms?: string | undefined;
    distance?: number | undefined;
    weight?: number | undefined;
    commodity?: any | undefined;
    originCountry?: string | undefined;
    originState?: string | undefined;
    originCity?: string | undefined;
    originZip?: string | undefined;
    destinationCountry?: string | undefined;
    destinationState?: string | undefined;
    destinationCity?: string | undefined;
    destinationZip?: string | undefined;
    extraStops?: any[] | undefined;
    carrierName?: any | undefined;
    carrierPhoneNumber?: any | undefined;
    carrierEmail?: any | undefined;
    customerName?: string | undefined;
    customerPhoneNumber?: any | undefined;
    customerEmail?: any | undefined;
    sellRate?: number | undefined;
    buySideRep?: any | undefined;
    sellSideRep?: any | undefined;
    loadProNumber?: string | undefined;
    currency?: string | undefined;

    constructor(data?: IGreenscreensDataLakeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCarrierCost = _data["totalCarrierCost"];
            this.totalCarrierRate = _data["totalCarrierRate"];
            this.loadPickupDate = _data["loadPickupDate"];
            this.pickupDateTime = _data["pickupDateTime"] ? DateTime.fromISO(_data["pickupDateTime"].toString()) : <any>undefined;
            this.deliveredDateTime = _data["deliveredDateTime"] ? DateTime.fromISO(_data["deliveredDateTime"].toString()) : <any>undefined;
            this.transportTypeTms = _data["transportTypeTms"];
            this.distance = _data["distance"];
            this.weight = _data["weight"];
            this.commodity = _data["commodity"];
            this.originCountry = _data["originCountry"];
            this.originState = _data["originState"];
            this.originCity = _data["originCity"];
            this.originZip = _data["originZip"];
            this.destinationCountry = _data["destinationCountry"];
            this.destinationState = _data["destinationState"];
            this.destinationCity = _data["destinationCity"];
            this.destinationZip = _data["destinationZip"];
            if (Array.isArray(_data["extraStops"])) {
                this.extraStops = [] as any;
                for (let item of _data["extraStops"])
                    this.extraStops!.push(item);
            }
            this.carrierName = _data["carrierName"];
            this.carrierPhoneNumber = _data["carrierPhoneNumber"];
            this.carrierEmail = _data["carrierEmail"];
            this.customerName = _data["customerName"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.customerEmail = _data["customerEmail"];
            this.sellRate = _data["sellRate"];
            this.buySideRep = _data["buySideRep"];
            this.sellSideRep = _data["sellSideRep"];
            this.loadProNumber = _data["loadProNumber"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GreenscreensDataLakeItem {
        data = typeof data === 'object' ? data : {};
        let result = new GreenscreensDataLakeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCarrierCost"] = this.totalCarrierCost;
        data["totalCarrierRate"] = this.totalCarrierRate;
        data["loadPickupDate"] = this.loadPickupDate;
        data["pickupDateTime"] = this.pickupDateTime ? this.pickupDateTime.toString() : <any>undefined;
        data["deliveredDateTime"] = this.deliveredDateTime ? this.deliveredDateTime.toString() : <any>undefined;
        data["transportTypeTms"] = this.transportTypeTms;
        data["distance"] = this.distance;
        data["weight"] = this.weight;
        data["commodity"] = this.commodity;
        data["originCountry"] = this.originCountry;
        data["originState"] = this.originState;
        data["originCity"] = this.originCity;
        data["originZip"] = this.originZip;
        data["destinationCountry"] = this.destinationCountry;
        data["destinationState"] = this.destinationState;
        data["destinationCity"] = this.destinationCity;
        data["destinationZip"] = this.destinationZip;
        if (Array.isArray(this.extraStops)) {
            data["extraStops"] = [];
            for (let item of this.extraStops)
                data["extraStops"].push(item);
        }
        data["carrierName"] = this.carrierName;
        data["carrierPhoneNumber"] = this.carrierPhoneNumber;
        data["carrierEmail"] = this.carrierEmail;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["customerEmail"] = this.customerEmail;
        data["sellRate"] = this.sellRate;
        data["buySideRep"] = this.buySideRep;
        data["sellSideRep"] = this.sellSideRep;
        data["loadProNumber"] = this.loadProNumber;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGreenscreensDataLakeItem {
    totalCarrierCost?: number | undefined;
    totalCarrierRate?: number | undefined;
    loadPickupDate?: string | undefined;
    pickupDateTime?: DateTime | undefined;
    deliveredDateTime?: DateTime | undefined;
    transportTypeTms?: string | undefined;
    distance?: number | undefined;
    weight?: number | undefined;
    commodity?: any | undefined;
    originCountry?: string | undefined;
    originState?: string | undefined;
    originCity?: string | undefined;
    originZip?: string | undefined;
    destinationCountry?: string | undefined;
    destinationState?: string | undefined;
    destinationCity?: string | undefined;
    destinationZip?: string | undefined;
    extraStops?: any[] | undefined;
    carrierName?: any | undefined;
    carrierPhoneNumber?: any | undefined;
    carrierEmail?: any | undefined;
    customerName?: string | undefined;
    customerPhoneNumber?: any | undefined;
    customerEmail?: any | undefined;
    sellRate?: number | undefined;
    buySideRep?: any | undefined;
    sellSideRep?: any | undefined;
    loadProNumber?: string | undefined;
    currency?: string | undefined;
}

export class HistoricalLoadDto implements IHistoricalLoadDto {
    loadNumber?: string | undefined;
    buyRate?: number;
    total?: number;
    readonly ratePerMile?: number;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    pickupDate?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    deliveryDate?: string | undefined;
    mileage?: number;
    leadTimeHours?: number | undefined;
    transactionType?: string | undefined;

    constructor(data?: IHistoricalLoadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadNumber = _data["loadNumber"];
            this.buyRate = _data["buyRate"];
            this.total = _data["total"];
            (<any>this).ratePerMile = _data["ratePerMile"];
            this.originCity = _data["originCity"];
            this.originState = _data["originState"];
            this.originZip = _data["originZip"];
            this.pickupDate = _data["pickupDate"];
            this.destinationCity = _data["destinationCity"];
            this.destinationState = _data["destinationState"];
            this.destinationZip = _data["destinationZip"];
            this.deliveryDate = _data["deliveryDate"];
            this.mileage = _data["mileage"];
            this.leadTimeHours = _data["leadTimeHours"];
            this.transactionType = _data["transactionType"];
        }
    }

    static fromJS(data: any): HistoricalLoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalLoadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadNumber"] = this.loadNumber;
        data["buyRate"] = this.buyRate;
        data["total"] = this.total;
        data["ratePerMile"] = this.ratePerMile;
        data["originCity"] = this.originCity;
        data["originState"] = this.originState;
        data["originZip"] = this.originZip;
        data["pickupDate"] = this.pickupDate;
        data["destinationCity"] = this.destinationCity;
        data["destinationState"] = this.destinationState;
        data["destinationZip"] = this.destinationZip;
        data["deliveryDate"] = this.deliveryDate;
        data["mileage"] = this.mileage;
        data["leadTimeHours"] = this.leadTimeHours;
        data["transactionType"] = this.transactionType;
        return data;
    }
}

export interface IHistoricalLoadDto {
    loadNumber?: string | undefined;
    buyRate?: number;
    total?: number;
    ratePerMile?: number;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    pickupDate?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    deliveryDate?: string | undefined;
    mileage?: number;
    leadTimeHours?: number | undefined;
    transactionType?: string | undefined;
}

export class ImpersonationDto implements IImpersonationDto {
    impersonatedRoleId?: number;
    impersonatedTenantId?: number;

    constructor(data?: IImpersonationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonatedRoleId = _data["impersonatedRoleId"];
            this.impersonatedTenantId = _data["impersonatedTenantId"];
        }
    }

    static fromJS(data: any): ImpersonationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonatedRoleId"] = this.impersonatedRoleId;
        data["impersonatedTenantId"] = this.impersonatedTenantId;
        return data;
    }
}

export interface IImpersonationDto {
    impersonatedRoleId?: number;
    impersonatedTenantId?: number;
}

export class ImpersonationOptionsDto implements IImpersonationOptionsDto {
    roles?: ListItemDto[] | undefined;
    tenants?: TenantDto[] | undefined;

    constructor(data?: IImpersonationOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImpersonationOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImpersonationOptionsDto {
    roles?: ListItemDto[] | undefined;
    tenants?: TenantDto[] | undefined;
}

export class LaneInsightsDto implements ILaneInsightsDto {
    quoteId?: number;
    range?: number;
    laneOrigin?: string | undefined;
    laneDestination?: string | undefined;
    totalUncoveredLoads?: number;
    totalRecentlyCoveredLoads?: number;
    totalCarriers?: number;
    upcomingLoads?: LoadInfoDto[] | undefined;
    topCarrierReps?: CarrierRepInfoDto[] | undefined;
    topCarriers?: CarrierInfoDto[] | undefined;

    constructor(data?: ILaneInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.range = _data["range"];
            this.laneOrigin = _data["laneOrigin"];
            this.laneDestination = _data["laneDestination"];
            this.totalUncoveredLoads = _data["totalUncoveredLoads"];
            this.totalRecentlyCoveredLoads = _data["totalRecentlyCoveredLoads"];
            this.totalCarriers = _data["totalCarriers"];
            if (Array.isArray(_data["upcomingLoads"])) {
                this.upcomingLoads = [] as any;
                for (let item of _data["upcomingLoads"])
                    this.upcomingLoads!.push(LoadInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["topCarrierReps"])) {
                this.topCarrierReps = [] as any;
                for (let item of _data["topCarrierReps"])
                    this.topCarrierReps!.push(CarrierRepInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["topCarriers"])) {
                this.topCarriers = [] as any;
                for (let item of _data["topCarriers"])
                    this.topCarriers!.push(CarrierInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LaneInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaneInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["range"] = this.range;
        data["laneOrigin"] = this.laneOrigin;
        data["laneDestination"] = this.laneDestination;
        data["totalUncoveredLoads"] = this.totalUncoveredLoads;
        data["totalRecentlyCoveredLoads"] = this.totalRecentlyCoveredLoads;
        data["totalCarriers"] = this.totalCarriers;
        if (Array.isArray(this.upcomingLoads)) {
            data["upcomingLoads"] = [];
            for (let item of this.upcomingLoads)
                data["upcomingLoads"].push(item.toJSON());
        }
        if (Array.isArray(this.topCarrierReps)) {
            data["topCarrierReps"] = [];
            for (let item of this.topCarrierReps)
                data["topCarrierReps"].push(item.toJSON());
        }
        if (Array.isArray(this.topCarriers)) {
            data["topCarriers"] = [];
            for (let item of this.topCarriers)
                data["topCarriers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILaneInsightsDto {
    quoteId?: number;
    range?: number;
    laneOrigin?: string | undefined;
    laneDestination?: string | undefined;
    totalUncoveredLoads?: number;
    totalRecentlyCoveredLoads?: number;
    totalCarriers?: number;
    upcomingLoads?: LoadInfoDto[] | undefined;
    topCarrierReps?: CarrierRepInfoDto[] | undefined;
    topCarriers?: CarrierInfoDto[] | undefined;
}

export class LeadTimeBucketDto implements ILeadTimeBucketDto {
    id?: number;
    minimumHours?: number;
    maximumHours?: number;
    readonly maxIsInfinity?: boolean;

    constructor(data?: ILeadTimeBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minimumHours = _data["minimumHours"];
            this.maximumHours = _data["maximumHours"];
            (<any>this).maxIsInfinity = _data["maxIsInfinity"];
        }
    }

    static fromJS(data: any): LeadTimeBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadTimeBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minimumHours"] = this.minimumHours;
        data["maximumHours"] = this.maximumHours;
        data["maxIsInfinity"] = this.maxIsInfinity;
        return data;
    }
}

export interface ILeadTimeBucketDto {
    id?: number;
    minimumHours?: number;
    maximumHours?: number;
    maxIsInfinity?: boolean;
}

export class ListItemDto implements IListItemDto {
    value!: number;
    label!: string;

    constructor(data?: IListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IListItemDto {
    value: number;
    label: string;
}

export class LoadInfoDto implements ILoadInfoDto {
    loadId?: string | undefined;
    totalRate?: number;

    constructor(data?: ILoadInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            this.totalRate = _data["totalRate"];
        }
    }

    static fromJS(data: any): LoadInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["totalRate"] = this.totalRate;
        return data;
    }
}

export interface ILoadInfoDto {
    loadId?: string | undefined;
    totalRate?: number;
}

export class LoadToTruck implements ILoadToTruck {
    geoCode?: string | undefined;
    loadTruckRatios?: LoadToTruckRatio[] | undefined;

    constructor(data?: ILoadToTruck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geoCode = _data["geoCode"];
            if (Array.isArray(_data["loadTruckRatios"])) {
                this.loadTruckRatios = [] as any;
                for (let item of _data["loadTruckRatios"])
                    this.loadTruckRatios!.push(LoadToTruckRatio.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoadToTruck {
        data = typeof data === 'object' ? data : {};
        let result = new LoadToTruck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geoCode"] = this.geoCode;
        if (Array.isArray(this.loadTruckRatios)) {
            data["loadTruckRatios"] = [];
            for (let item of this.loadTruckRatios)
                data["loadTruckRatios"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILoadToTruck {
    geoCode?: string | undefined;
    loadTruckRatios?: LoadToTruckRatio[] | undefined;
}

export class LoadToTruckRatio implements ILoadToTruckRatio {
    date?: string | undefined;
    loads?: number;
    trucks?: number;
    ratio?: string | undefined;

    constructor(data?: ILoadToTruckRatio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.loads = _data["loads"];
            this.trucks = _data["trucks"];
            this.ratio = _data["ratio"];
        }
    }

    static fromJS(data: any): LoadToTruckRatio {
        data = typeof data === 'object' ? data : {};
        let result = new LoadToTruckRatio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["loads"] = this.loads;
        data["trucks"] = this.trucks;
        data["ratio"] = this.ratio;
        return data;
    }
}

export interface ILoadToTruckRatio {
    date?: string | undefined;
    loads?: number;
    trucks?: number;
    ratio?: string | undefined;
}

export enum LocationFilterLevel {
    City = "City",
    Zip = "Zip",
    State = "State",
    Market = "Market",
    PricingRegion = "PricingRegion",
}

export class MarketPricingDto implements IMarketPricingDto {
    sourceName?: string | undefined;
    targetBuyRate?: number | undefined;
    low?: number | undefined;
    high?: number | undefined;
    confidenceLevel?: number | undefined;
    additionalInfo?: { [key: string]: string; } | undefined;

    constructor(data?: IMarketPricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.targetBuyRate = _data["targetBuyRate"];
            this.low = _data["low"];
            this.high = _data["high"];
            this.confidenceLevel = _data["confidenceLevel"];
            if (_data["additionalInfo"]) {
                this.additionalInfo = {} as any;
                for (let key in _data["additionalInfo"]) {
                    if (_data["additionalInfo"].hasOwnProperty(key))
                        (<any>this.additionalInfo)![key] = _data["additionalInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): MarketPricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketPricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["targetBuyRate"] = this.targetBuyRate;
        data["low"] = this.low;
        data["high"] = this.high;
        data["confidenceLevel"] = this.confidenceLevel;
        if (this.additionalInfo) {
            data["additionalInfo"] = {};
            for (let key in this.additionalInfo) {
                if (this.additionalInfo.hasOwnProperty(key))
                    (<any>data["additionalInfo"])[key] = (<any>this.additionalInfo)[key];
            }
        }
        return data;
    }
}

export interface IMarketPricingDto {
    sourceName?: string | undefined;
    targetBuyRate?: number | undefined;
    low?: number | undefined;
    high?: number | undefined;
    confidenceLevel?: number | undefined;
    additionalInfo?: { [key: string]: string; } | undefined;
}

export class MarkupConditionDto implements IMarkupConditionDto {
    fieldName?: string | undefined;
    value?: string | undefined;

    constructor(data?: IMarkupConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MarkupConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["value"] = this.value;
        return data;
    }
}

export interface IMarkupConditionDto {
    fieldName?: string | undefined;
    value?: string | undefined;
}

export class MarkupDto implements IMarkupDto {
    id?: number;
    enabled?: boolean;
    markupValue?: number;
    markupPercent?: number;
    amount?: number;
    type?: string | undefined;
    isCustom?: boolean;
    isDeleted?: boolean;
    conditions?: MarkupConditionDto[] | undefined;

    constructor(data?: IMarkupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.markupValue = _data["markupValue"];
            this.markupPercent = _data["markupPercent"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.isCustom = _data["isCustom"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(MarkupConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["markupValue"] = this.markupValue;
        data["markupPercent"] = this.markupPercent;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["isCustom"] = this.isCustom;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkupDto {
    id?: number;
    enabled?: boolean;
    markupValue?: number;
    markupPercent?: number;
    amount?: number;
    type?: string | undefined;
    isCustom?: boolean;
    isDeleted?: boolean;
    conditions?: MarkupConditionDto[] | undefined;
}

export class MarkupModel implements IMarkupModel {
    ruleName?: string | undefined;
    markupAmount?: number;
    markupType?: string | undefined;
    matchedConditions?: RulesEngineConditionModel[] | undefined;

    constructor(data?: IMarkupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleName = _data["ruleName"];
            this.markupAmount = _data["markupAmount"];
            this.markupType = _data["markupType"];
            if (Array.isArray(_data["matchedConditions"])) {
                this.matchedConditions = [] as any;
                for (let item of _data["matchedConditions"])
                    this.matchedConditions!.push(RulesEngineConditionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkupModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleName"] = this.ruleName;
        data["markupAmount"] = this.markupAmount;
        data["markupType"] = this.markupType;
        if (Array.isArray(this.matchedConditions)) {
            data["matchedConditions"] = [];
            for (let item of this.matchedConditions)
                data["matchedConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkupModel {
    ruleName?: string | undefined;
    markupAmount?: number;
    markupType?: string | undefined;
    matchedConditions?: RulesEngineConditionModel[] | undefined;
}

export class MileageBucketDto implements IMileageBucketDto {
    id?: number;
    minimumRange?: number;
    maximumRange?: number;
    readonly maxIsInfinity?: boolean;

    constructor(data?: IMileageBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minimumRange = _data["minimumRange"];
            this.maximumRange = _data["maximumRange"];
            (<any>this).maxIsInfinity = _data["maxIsInfinity"];
        }
    }

    static fromJS(data: any): MileageBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new MileageBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minimumRange"] = this.minimumRange;
        data["maximumRange"] = this.maximumRange;
        data["maxIsInfinity"] = this.maxIsInfinity;
        return data;
    }
}

export interface IMileageBucketDto {
    id?: number;
    minimumRange?: number;
    maximumRange?: number;
    maxIsInfinity?: boolean;
}

export class OfficeDto implements IOfficeDto {
    id?: number;
    name?: string | undefined;
    accounts?: AccountDto[] | undefined;

    constructor(data?: IOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(AccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficeDto {
    id?: number;
    name?: string | undefined;
    accounts?: AccountDto[] | undefined;
}

export class OriginDestination implements IOriginDestination {
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IOriginDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): OriginDestination {
        data = typeof data === 'object' ? data : {};
        let result = new OriginDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IOriginDestination {
    name?: string | undefined;
    type?: string | undefined;
}

export class OverridePricingRequestDto implements IOverridePricingRequestDto {
    quoteId?: number;
    overrideType?: string | undefined;
    overrideValue?: number;

    constructor(data?: IOverridePricingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.overrideType = _data["overrideType"];
            this.overrideValue = _data["overrideValue"];
        }
    }

    static fromJS(data: any): OverridePricingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverridePricingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["overrideType"] = this.overrideType;
        data["overrideValue"] = this.overrideValue;
        return data;
    }
}

export interface IOverridePricingRequestDto {
    quoteId?: number;
    overrideType?: string | undefined;
    overrideValue?: number;
}

export class PagingDto implements IPagingDto {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPagingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagingDto {
    pageNumber?: number;
    pageSize?: number;
}

export class PerMileTrip implements IPerMileTrip {
    rateUsd?: number;
    highUsd?: number;
    lowUsd?: number;

    constructor(data?: IPerMileTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateUsd = _data["rateUsd"];
            this.highUsd = _data["highUsd"];
            this.lowUsd = _data["lowUsd"];
        }
    }

    static fromJS(data: any): PerMileTrip {
        data = typeof data === 'object' ? data : {};
        let result = new PerMileTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateUsd"] = this.rateUsd;
        data["highUsd"] = this.highUsd;
        data["lowUsd"] = this.lowUsd;
        return data;
    }
}

export interface IPerMileTrip {
    rateUsd?: number;
    highUsd?: number;
    lowUsd?: number;
}

export class PricingOverrideDto implements IPricingOverrideDto {
    overrideType?: string | undefined;
    overrideValue?: number;

    constructor(data?: IPricingOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overrideType = _data["overrideType"];
            this.overrideValue = _data["overrideValue"];
        }
    }

    static fromJS(data: any): PricingOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overrideType"] = this.overrideType;
        data["overrideValue"] = this.overrideValue;
        return data;
    }
}

export interface IPricingOverrideDto {
    overrideType?: string | undefined;
    overrideValue?: number;
}

export class PricingParameterValueDto implements IPricingParameterValueDto {
    id?: number;
    regionId?: number;
    equipmentTypeId?: number;
    mileageBucketId?: number;
    leadTimeBucketId?: number | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;

    constructor(data?: IPricingParameterValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.equipmentTypeId = _data["equipmentTypeId"];
            this.mileageBucketId = _data["mileageBucketId"];
            this.leadTimeBucketId = _data["leadTimeBucketId"];
            this.minimumMarkup = _data["minimumMarkup"];
            this.minimumAmount = _data["minimumAmount"];
        }
    }

    static fromJS(data: any): PricingParameterValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingParameterValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["equipmentTypeId"] = this.equipmentTypeId;
        data["mileageBucketId"] = this.mileageBucketId;
        data["leadTimeBucketId"] = this.leadTimeBucketId;
        data["minimumMarkup"] = this.minimumMarkup;
        data["minimumAmount"] = this.minimumAmount;
        return data;
    }
}

export interface IPricingParameterValueDto {
    id?: number;
    regionId?: number;
    equipmentTypeId?: number;
    mileageBucketId?: number;
    leadTimeBucketId?: number | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;
}

export class PricingParametersDto implements IPricingParametersDto {
    regions?: PricingRegionDto[] | undefined;
    leadTimeBuckets?: LeadTimeBucketDto[] | undefined;
    mileageBuckets?: MileageBucketDto[] | undefined;
    equipmentTypes?: ListItemDto[] | undefined;
    values?: PricingParameterValueDto[] | undefined;

    constructor(data?: IPricingParametersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(PricingRegionDto.fromJS(item));
            }
            if (Array.isArray(_data["leadTimeBuckets"])) {
                this.leadTimeBuckets = [] as any;
                for (let item of _data["leadTimeBuckets"])
                    this.leadTimeBuckets!.push(LeadTimeBucketDto.fromJS(item));
            }
            if (Array.isArray(_data["mileageBuckets"])) {
                this.mileageBuckets = [] as any;
                for (let item of _data["mileageBuckets"])
                    this.mileageBuckets!.push(MileageBucketDto.fromJS(item));
            }
            if (Array.isArray(_data["equipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["equipmentTypes"])
                    this.equipmentTypes!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(PricingParameterValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        if (Array.isArray(this.leadTimeBuckets)) {
            data["leadTimeBuckets"] = [];
            for (let item of this.leadTimeBuckets)
                data["leadTimeBuckets"].push(item.toJSON());
        }
        if (Array.isArray(this.mileageBuckets)) {
            data["mileageBuckets"] = [];
            for (let item of this.mileageBuckets)
                data["mileageBuckets"].push(item.toJSON());
        }
        if (Array.isArray(this.equipmentTypes)) {
            data["equipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["equipmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricingParametersDto {
    regions?: PricingRegionDto[] | undefined;
    leadTimeBuckets?: LeadTimeBucketDto[] | undefined;
    mileageBuckets?: MileageBucketDto[] | undefined;
    equipmentTypes?: ListItemDto[] | undefined;
    values?: PricingParameterValueDto[] | undefined;
}

export class PricingRegionDto implements IPricingRegionDto {
    regionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    minimumMarkup?: number;

    constructor(data?: IPricingRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.minimumMarkup = _data["minimumMarkup"];
        }
    }

    static fromJS(data: any): PricingRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["minimumMarkup"] = this.minimumMarkup;
        return data;
    }
}

export interface IPricingRegionDto {
    regionId?: number;
    name?: string | undefined;
    description?: string | undefined;
    minimumMarkup?: number;
}

export class PricingUpdate implements IPricingUpdate {
    quoteId?: number;
    markups?: MarkupDto[] | undefined;

    constructor(data?: IPricingUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            if (Array.isArray(_data["markups"])) {
                this.markups = [] as any;
                for (let item of _data["markups"])
                    this.markups!.push(MarkupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new PricingUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        if (Array.isArray(this.markups)) {
            data["markups"] = [];
            for (let item of this.markups)
                data["markups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricingUpdate {
    quoteId?: number;
    markups?: MarkupDto[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProjectedCostDto implements IProjectedCostDto {
    companyRate?: GreenScreensProjectedCostDto;
    networkRate?: GreenScreensProjectedCostDto;
    datProjectedCosts?: DatProjectedCost[] | undefined;
    truckStopProjectedCost?: TruckStopProjectedCost;

    constructor(data?: IProjectedCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRate = _data["companyRate"] ? GreenScreensProjectedCostDto.fromJS(_data["companyRate"]) : <any>undefined;
            this.networkRate = _data["networkRate"] ? GreenScreensProjectedCostDto.fromJS(_data["networkRate"]) : <any>undefined;
            if (Array.isArray(_data["datProjectedCosts"])) {
                this.datProjectedCosts = [] as any;
                for (let item of _data["datProjectedCosts"])
                    this.datProjectedCosts!.push(DatProjectedCost.fromJS(item));
            }
            this.truckStopProjectedCost = _data["truckStopProjectedCost"] ? TruckStopProjectedCost.fromJS(_data["truckStopProjectedCost"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectedCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectedCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRate"] = this.companyRate ? this.companyRate.toJSON() : <any>undefined;
        data["networkRate"] = this.networkRate ? this.networkRate.toJSON() : <any>undefined;
        if (Array.isArray(this.datProjectedCosts)) {
            data["datProjectedCosts"] = [];
            for (let item of this.datProjectedCosts)
                data["datProjectedCosts"].push(item.toJSON());
        }
        data["truckStopProjectedCost"] = this.truckStopProjectedCost ? this.truckStopProjectedCost.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectedCostDto {
    companyRate?: GreenScreensProjectedCostDto;
    networkRate?: GreenScreensProjectedCostDto;
    datProjectedCosts?: DatProjectedCost[] | undefined;
    truckStopProjectedCost?: TruckStopProjectedCost;
}

export class PublicAPIErrorLogDto implements IPublicAPIErrorLogDto {
    id?: number;
    accountId?: number | undefined;
    account?: AccountDto;
    errorList?: string | undefined;
    requestedQuote?: string | undefined;
    createdBy?: UserDto;
    createdOnUtc?: DateTime;

    constructor(data?: IPublicAPIErrorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
            this.errorList = _data["errorList"];
            this.requestedQuote = _data["requestedQuote"];
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PublicAPIErrorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicAPIErrorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["errorList"] = this.errorList;
        data["requestedQuote"] = this.requestedQuote;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>undefined;
        return data;
    }
}

export interface IPublicAPIErrorLogDto {
    id?: number;
    accountId?: number | undefined;
    account?: AccountDto;
    errorList?: string | undefined;
    requestedQuote?: string | undefined;
    createdBy?: UserDto;
    createdOnUtc?: DateTime;
}

export class PublicQuoteDto implements IPublicQuoteDto {
    companyName?: string | undefined;
    equipment?: string | undefined;
    commodity?: string | undefined;
    specializedServices?: ListItemDto[] | undefined;
    origin?: StopDto;
    destination?: StopDto;
    status?: string | undefined;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    totalRate?: number;

    constructor(data?: IPublicQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.equipment = _data["equipment"];
            this.commodity = _data["commodity"];
            if (Array.isArray(_data["specializedServices"])) {
                this.specializedServices = [] as any;
                for (let item of _data["specializedServices"])
                    this.specializedServices!.push(ListItemDto.fromJS(item));
            }
            this.origin = _data["origin"] ? StopDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? StopDto.fromJS(_data["destination"]) : <any>undefined;
            this.status = _data["status"];
            this.pickupDate = _data["pickupDate"] ? DateTime.fromISO(_data["pickupDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : <any>undefined;
            this.estimatedPickupHour = _data["estimatedPickupHour"];
            this.estimatedDeliveryHour = _data["estimatedDeliveryHour"];
            this.estimatedPickupMinute = _data["estimatedPickupMinute"];
            this.estimatedDeliveryMinute = _data["estimatedDeliveryMinute"];
            this.totalRate = _data["totalRate"];
        }
    }

    static fromJS(data: any): PublicQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["equipment"] = this.equipment;
        data["commodity"] = this.commodity;
        if (Array.isArray(this.specializedServices)) {
            data["specializedServices"] = [];
            for (let item of this.specializedServices)
                data["specializedServices"].push(item.toJSON());
        }
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : <any>undefined;
        data["estimatedPickupHour"] = this.estimatedPickupHour;
        data["estimatedDeliveryHour"] = this.estimatedDeliveryHour;
        data["estimatedPickupMinute"] = this.estimatedPickupMinute;
        data["estimatedDeliveryMinute"] = this.estimatedDeliveryMinute;
        data["totalRate"] = this.totalRate;
        return data;
    }
}

export interface IPublicQuoteDto {
    companyName?: string | undefined;
    equipment?: string | undefined;
    commodity?: string | undefined;
    specializedServices?: ListItemDto[] | undefined;
    origin?: StopDto;
    destination?: StopDto;
    status?: string | undefined;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    totalRate?: number;
}

export class QuoteHistoryDto implements IQuoteHistoryDto {
    id?: number;
    readonly hashedId?: string | undefined;
    account?: AccountDto;
    equipment?: string | undefined;
    stops?: StopDto[] | undefined;
    status?: string | undefined;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    totalRate?: number;
    targetBuyRate?: number | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    createdById?: number;
    createdOn?: DateTime | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    readonly bHashedId?: string | undefined;
    batchId?: number;
    leadTimeInHours?: number;
    mileage?: number | undefined;
    readonly ratePerMile?: number | undefined;

    constructor(data?: IQuoteHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).hashedId = _data["hashedId"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
            this.equipment = _data["equipment"];
            if (Array.isArray(_data["stops"])) {
                this.stops = [] as any;
                for (let item of _data["stops"])
                    this.stops!.push(StopDto.fromJS(item));
            }
            this.status = _data["status"];
            this.pickupDate = _data["pickupDate"] ? DateTime.fromISO(_data["pickupDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : <any>undefined;
            this.totalRate = _data["totalRate"];
            this.targetBuyRate = _data["targetBuyRate"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByName = _data["createdByName"];
            this.createdById = _data["createdById"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : <any>undefined;
            this.estimatedPickupHour = _data["estimatedPickupHour"];
            this.estimatedDeliveryHour = _data["estimatedDeliveryHour"];
            this.estimatedPickupMinute = _data["estimatedPickupMinute"];
            this.estimatedDeliveryMinute = _data["estimatedDeliveryMinute"];
            (<any>this).bHashedId = _data["bHashedId"];
            this.batchId = _data["batchId"];
            this.leadTimeInHours = _data["leadTimeInHours"];
            this.mileage = _data["mileage"];
            (<any>this).ratePerMile = _data["ratePerMile"];
        }
    }

    static fromJS(data: any): QuoteHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hashedId"] = this.hashedId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["equipment"] = this.equipment;
        if (Array.isArray(this.stops)) {
            data["stops"] = [];
            for (let item of this.stops)
                data["stops"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : <any>undefined;
        data["totalRate"] = this.totalRate;
        data["targetBuyRate"] = this.targetBuyRate;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByName"] = this.createdByName;
        data["createdById"] = this.createdById;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : <any>undefined;
        data["estimatedPickupHour"] = this.estimatedPickupHour;
        data["estimatedDeliveryHour"] = this.estimatedDeliveryHour;
        data["estimatedPickupMinute"] = this.estimatedPickupMinute;
        data["estimatedDeliveryMinute"] = this.estimatedDeliveryMinute;
        data["bHashedId"] = this.bHashedId;
        data["batchId"] = this.batchId;
        data["leadTimeInHours"] = this.leadTimeInHours;
        data["mileage"] = this.mileage;
        data["ratePerMile"] = this.ratePerMile;
        return data;
    }
}

export interface IQuoteHistoryDto {
    id?: number;
    hashedId?: string | undefined;
    account?: AccountDto;
    equipment?: string | undefined;
    stops?: StopDto[] | undefined;
    status?: string | undefined;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    totalRate?: number;
    targetBuyRate?: number | undefined;
    createdByEmail?: string | undefined;
    createdByName?: string | undefined;
    createdById?: number;
    createdOn?: DateTime | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    bHashedId?: string | undefined;
    batchId?: number;
    leadTimeInHours?: number;
    mileage?: number | undefined;
    ratePerMile?: number | undefined;
}

export class QuoteHistoryFilterOptions implements IQuoteHistoryFilterOptions {
    batchHashedId?: string | undefined;
    equipment?: string | undefined;
    status?: string | undefined;

    constructor(data?: IQuoteHistoryFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchHashedId = _data["batchHashedId"];
            this.equipment = _data["equipment"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): QuoteHistoryFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteHistoryFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchHashedId"] = this.batchHashedId;
        data["equipment"] = this.equipment;
        data["status"] = this.status;
        return data;
    }
}

export interface IQuoteHistoryFilterOptions {
    batchHashedId?: string | undefined;
    equipment?: string | undefined;
    status?: string | undefined;
}

export class QuotePricingDto implements IQuotePricingDto {
    id?: number;
    targetBuyRate?: number;
    originalTargetSellRate?: number;
    originalTargetRpm?: number;
    originalMarkupAmountTotal?: number;
    originalMarkupPercentTotal?: number;
    targetSellRate?: number;
    targetRpm?: number;
    markupAmountTotal?: number;
    markupPercentTotal?: number;

    constructor(data?: IQuotePricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetBuyRate = _data["targetBuyRate"];
            this.originalTargetSellRate = _data["originalTargetSellRate"];
            this.originalTargetRpm = _data["originalTargetRpm"];
            this.originalMarkupAmountTotal = _data["originalMarkupAmountTotal"];
            this.originalMarkupPercentTotal = _data["originalMarkupPercentTotal"];
            this.targetSellRate = _data["targetSellRate"];
            this.targetRpm = _data["targetRpm"];
            this.markupAmountTotal = _data["markupAmountTotal"];
            this.markupPercentTotal = _data["markupPercentTotal"];
        }
    }

    static fromJS(data: any): QuotePricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetBuyRate"] = this.targetBuyRate;
        data["originalTargetSellRate"] = this.originalTargetSellRate;
        data["originalTargetRpm"] = this.originalTargetRpm;
        data["originalMarkupAmountTotal"] = this.originalMarkupAmountTotal;
        data["originalMarkupPercentTotal"] = this.originalMarkupPercentTotal;
        data["targetSellRate"] = this.targetSellRate;
        data["targetRpm"] = this.targetRpm;
        data["markupAmountTotal"] = this.markupAmountTotal;
        data["markupPercentTotal"] = this.markupPercentTotal;
        return data;
    }
}

export interface IQuotePricingDto {
    id?: number;
    targetBuyRate?: number;
    originalTargetSellRate?: number;
    originalTargetRpm?: number;
    originalMarkupAmountTotal?: number;
    originalMarkupPercentTotal?: number;
    targetSellRate?: number;
    targetRpm?: number;
    markupAmountTotal?: number;
    markupPercentTotal?: number;
}

export class QuoteRequestDto implements IQuoteRequestDto {
    id?: number;
    accountId?: number;
    equipmentId?: number;
    temperatureMax?: string | undefined;
    temperatureMin?: string | undefined;
    tarpsRequired?: boolean;
    oversize?: boolean;
    pickupDate?: string | undefined;
    deliveryDate?: string | undefined;
    commodityId?: number | undefined;
    specializedServiceIds?: number[] | undefined;
    shipperName?: string | undefined;
    receiverName?: string | undefined;
    referenceNumber?: string | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    originAddressZipCode?: string | undefined;
    originAddressCity?: string | undefined;
    originAddressState?: string | undefined;
    originLat?: string | undefined;
    originLng?: string | undefined;
    destinationAddressZipCode?: string | undefined;
    destinationAddressCity?: string | undefined;
    destinationAddressState?: string | undefined;
    destinationLat?: string | undefined;
    destinationLng?: string | undefined;
    isTestQuote?: boolean | undefined;

    constructor(data?: IQuoteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.equipmentId = _data["equipmentId"];
            this.temperatureMax = _data["temperatureMax"];
            this.temperatureMin = _data["temperatureMin"];
            this.tarpsRequired = _data["tarpsRequired"];
            this.oversize = _data["oversize"];
            this.pickupDate = _data["pickupDate"];
            this.deliveryDate = _data["deliveryDate"];
            this.commodityId = _data["commodityId"];
            if (Array.isArray(_data["specializedServiceIds"])) {
                this.specializedServiceIds = [] as any;
                for (let item of _data["specializedServiceIds"])
                    this.specializedServiceIds!.push(item);
            }
            this.shipperName = _data["shipperName"];
            this.receiverName = _data["receiverName"];
            this.referenceNumber = _data["referenceNumber"];
            this.estimatedPickupHour = _data["estimatedPickupHour"];
            this.estimatedDeliveryHour = _data["estimatedDeliveryHour"];
            this.estimatedPickupMinute = _data["estimatedPickupMinute"];
            this.estimatedDeliveryMinute = _data["estimatedDeliveryMinute"];
            this.originAddressZipCode = _data["originAddressZipCode"];
            this.originAddressCity = _data["originAddressCity"];
            this.originAddressState = _data["originAddressState"];
            this.originLat = _data["originLat"];
            this.originLng = _data["originLng"];
            this.destinationAddressZipCode = _data["destinationAddressZipCode"];
            this.destinationAddressCity = _data["destinationAddressCity"];
            this.destinationAddressState = _data["destinationAddressState"];
            this.destinationLat = _data["destinationLat"];
            this.destinationLng = _data["destinationLng"];
            this.isTestQuote = _data["isTestQuote"];
        }
    }

    static fromJS(data: any): QuoteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["equipmentId"] = this.equipmentId;
        data["temperatureMax"] = this.temperatureMax;
        data["temperatureMin"] = this.temperatureMin;
        data["tarpsRequired"] = this.tarpsRequired;
        data["oversize"] = this.oversize;
        data["pickupDate"] = this.pickupDate;
        data["deliveryDate"] = this.deliveryDate;
        data["commodityId"] = this.commodityId;
        if (Array.isArray(this.specializedServiceIds)) {
            data["specializedServiceIds"] = [];
            for (let item of this.specializedServiceIds)
                data["specializedServiceIds"].push(item);
        }
        data["shipperName"] = this.shipperName;
        data["receiverName"] = this.receiverName;
        data["referenceNumber"] = this.referenceNumber;
        data["estimatedPickupHour"] = this.estimatedPickupHour;
        data["estimatedDeliveryHour"] = this.estimatedDeliveryHour;
        data["estimatedPickupMinute"] = this.estimatedPickupMinute;
        data["estimatedDeliveryMinute"] = this.estimatedDeliveryMinute;
        data["originAddressZipCode"] = this.originAddressZipCode;
        data["originAddressCity"] = this.originAddressCity;
        data["originAddressState"] = this.originAddressState;
        data["originLat"] = this.originLat;
        data["originLng"] = this.originLng;
        data["destinationAddressZipCode"] = this.destinationAddressZipCode;
        data["destinationAddressCity"] = this.destinationAddressCity;
        data["destinationAddressState"] = this.destinationAddressState;
        data["destinationLat"] = this.destinationLat;
        data["destinationLng"] = this.destinationLng;
        data["isTestQuote"] = this.isTestQuote;
        return data;
    }
}

export interface IQuoteRequestDto {
    id?: number;
    accountId?: number;
    equipmentId?: number;
    temperatureMax?: string | undefined;
    temperatureMin?: string | undefined;
    tarpsRequired?: boolean;
    oversize?: boolean;
    pickupDate?: string | undefined;
    deliveryDate?: string | undefined;
    commodityId?: number | undefined;
    specializedServiceIds?: number[] | undefined;
    shipperName?: string | undefined;
    receiverName?: string | undefined;
    referenceNumber?: string | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    originAddressZipCode?: string | undefined;
    originAddressCity?: string | undefined;
    originAddressState?: string | undefined;
    originLat?: string | undefined;
    originLng?: string | undefined;
    destinationAddressZipCode?: string | undefined;
    destinationAddressCity?: string | undefined;
    destinationAddressState?: string | undefined;
    destinationLat?: string | undefined;
    destinationLng?: string | undefined;
    isTestQuote?: boolean | undefined;
}

export class QuoteResponseDto implements IQuoteResponseDto {
    hashedId?: string | undefined;
    id?: number;
    regionName?: string | undefined;
    leadTimeInHours?: number;
    mileage?: number | undefined;
    createdOnUtc?: DateTime;
    createdBy?: UserDto;
    specializedServices?: ListItemDto[] | undefined;
    commodity?: ListItemDto;
    account?: AccountDto;
    equipmentType?: ListItemDto;
    projectedCost?: ProjectedCostDto;
    status?: string | undefined;
    temperatureMax?: string | undefined;
    temperatureMin?: string | undefined;
    tarpsRequired?: boolean;
    oversize?: boolean;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    referenceNumber?: string | undefined;
    shipperName?: string | undefined;
    receiverName?: string | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    batchId?: number;
    stops?: StopDto[] | undefined;
    readonly leadTimeRange?: string | undefined;
    quoteTargetSellRateDto?: QuoteTargetSellRateDto;
    overriddenQuoteTargetSellRateDto?: QuoteTargetSellRateDto;
    message?: ErrorMessage;
    pricingOverrideDto?: PricingOverrideDto;
    overrideUpdatedBy?: UserDto;
    overrideUpdatedOnUtc?: DateTime | undefined;
    trackingDetails?: QuoteTrackingDto;
    quotePricing?: QuotePricingDto;
    readonly markups?: MarkupDto[] | undefined;
    readonly marketPricing?: MarketPricingDto[] | undefined;

    constructor(data?: IQuoteResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashedId = _data["hashedId"];
            this.id = _data["id"];
            this.regionName = _data["regionName"];
            this.leadTimeInHours = _data["leadTimeInHours"];
            this.mileage = _data["mileage"];
            this.createdOnUtc = _data["createdOnUtc"] ? DateTime.fromISO(_data["createdOnUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            if (Array.isArray(_data["specializedServices"])) {
                this.specializedServices = [] as any;
                for (let item of _data["specializedServices"])
                    this.specializedServices!.push(ListItemDto.fromJS(item));
            }
            this.commodity = _data["commodity"] ? ListItemDto.fromJS(_data["commodity"]) : <any>undefined;
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
            this.equipmentType = _data["equipmentType"] ? ListItemDto.fromJS(_data["equipmentType"]) : <any>undefined;
            this.projectedCost = _data["projectedCost"] ? ProjectedCostDto.fromJS(_data["projectedCost"]) : <any>undefined;
            this.status = _data["status"];
            this.temperatureMax = _data["temperatureMax"];
            this.temperatureMin = _data["temperatureMin"];
            this.tarpsRequired = _data["tarpsRequired"];
            this.oversize = _data["oversize"];
            this.pickupDate = _data["pickupDate"] ? DateTime.fromISO(_data["pickupDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : <any>undefined;
            this.referenceNumber = _data["referenceNumber"];
            this.shipperName = _data["shipperName"];
            this.receiverName = _data["receiverName"];
            this.estimatedPickupHour = _data["estimatedPickupHour"];
            this.estimatedDeliveryHour = _data["estimatedDeliveryHour"];
            this.minimumMarkup = _data["minimumMarkup"];
            this.minimumAmount = _data["minimumAmount"];
            this.estimatedPickupMinute = _data["estimatedPickupMinute"];
            this.estimatedDeliveryMinute = _data["estimatedDeliveryMinute"];
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["stops"])) {
                this.stops = [] as any;
                for (let item of _data["stops"])
                    this.stops!.push(StopDto.fromJS(item));
            }
            (<any>this).leadTimeRange = _data["leadTimeRange"];
            this.quoteTargetSellRateDto = _data["quoteTargetSellRateDto"] ? QuoteTargetSellRateDto.fromJS(_data["quoteTargetSellRateDto"]) : <any>undefined;
            this.overriddenQuoteTargetSellRateDto = _data["overriddenQuoteTargetSellRateDto"] ? QuoteTargetSellRateDto.fromJS(_data["overriddenQuoteTargetSellRateDto"]) : <any>undefined;
            this.message = _data["message"] ? ErrorMessage.fromJS(_data["message"]) : <any>undefined;
            this.pricingOverrideDto = _data["pricingOverrideDto"] ? PricingOverrideDto.fromJS(_data["pricingOverrideDto"]) : <any>undefined;
            this.overrideUpdatedBy = _data["overrideUpdatedBy"] ? UserDto.fromJS(_data["overrideUpdatedBy"]) : <any>undefined;
            this.overrideUpdatedOnUtc = _data["overrideUpdatedOnUtc"] ? DateTime.fromISO(_data["overrideUpdatedOnUtc"].toString()) : <any>undefined;
            this.trackingDetails = _data["trackingDetails"] ? QuoteTrackingDto.fromJS(_data["trackingDetails"]) : <any>undefined;
            this.quotePricing = _data["quotePricing"] ? QuotePricingDto.fromJS(_data["quotePricing"]) : <any>undefined;
            if (Array.isArray(_data["markups"])) {
                (<any>this).markups = [] as any;
                for (let item of _data["markups"])
                    (<any>this).markups!.push(MarkupDto.fromJS(item));
            }
            if (Array.isArray(_data["marketPricing"])) {
                (<any>this).marketPricing = [] as any;
                for (let item of _data["marketPricing"])
                    (<any>this).marketPricing!.push(MarketPricingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashedId"] = this.hashedId;
        data["id"] = this.id;
        data["regionName"] = this.regionName;
        data["leadTimeInHours"] = this.leadTimeInHours;
        data["mileage"] = this.mileage;
        data["createdOnUtc"] = this.createdOnUtc ? this.createdOnUtc.toString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        if (Array.isArray(this.specializedServices)) {
            data["specializedServices"] = [];
            for (let item of this.specializedServices)
                data["specializedServices"].push(item.toJSON());
        }
        data["commodity"] = this.commodity ? this.commodity.toJSON() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["equipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : <any>undefined;
        data["projectedCost"] = this.projectedCost ? this.projectedCost.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["temperatureMax"] = this.temperatureMax;
        data["temperatureMin"] = this.temperatureMin;
        data["tarpsRequired"] = this.tarpsRequired;
        data["oversize"] = this.oversize;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        data["shipperName"] = this.shipperName;
        data["receiverName"] = this.receiverName;
        data["estimatedPickupHour"] = this.estimatedPickupHour;
        data["estimatedDeliveryHour"] = this.estimatedDeliveryHour;
        data["minimumMarkup"] = this.minimumMarkup;
        data["minimumAmount"] = this.minimumAmount;
        data["estimatedPickupMinute"] = this.estimatedPickupMinute;
        data["estimatedDeliveryMinute"] = this.estimatedDeliveryMinute;
        data["batchId"] = this.batchId;
        if (Array.isArray(this.stops)) {
            data["stops"] = [];
            for (let item of this.stops)
                data["stops"].push(item.toJSON());
        }
        data["leadTimeRange"] = this.leadTimeRange;
        data["quoteTargetSellRateDto"] = this.quoteTargetSellRateDto ? this.quoteTargetSellRateDto.toJSON() : <any>undefined;
        data["overriddenQuoteTargetSellRateDto"] = this.overriddenQuoteTargetSellRateDto ? this.overriddenQuoteTargetSellRateDto.toJSON() : <any>undefined;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        data["pricingOverrideDto"] = this.pricingOverrideDto ? this.pricingOverrideDto.toJSON() : <any>undefined;
        data["overrideUpdatedBy"] = this.overrideUpdatedBy ? this.overrideUpdatedBy.toJSON() : <any>undefined;
        data["overrideUpdatedOnUtc"] = this.overrideUpdatedOnUtc ? this.overrideUpdatedOnUtc.toString() : <any>undefined;
        data["trackingDetails"] = this.trackingDetails ? this.trackingDetails.toJSON() : <any>undefined;
        data["quotePricing"] = this.quotePricing ? this.quotePricing.toJSON() : <any>undefined;
        if (Array.isArray(this.markups)) {
            data["markups"] = [];
            for (let item of this.markups)
                data["markups"].push(item.toJSON());
        }
        if (Array.isArray(this.marketPricing)) {
            data["marketPricing"] = [];
            for (let item of this.marketPricing)
                data["marketPricing"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuoteResponseDto {
    hashedId?: string | undefined;
    id?: number;
    regionName?: string | undefined;
    leadTimeInHours?: number;
    mileage?: number | undefined;
    createdOnUtc?: DateTime;
    createdBy?: UserDto;
    specializedServices?: ListItemDto[] | undefined;
    commodity?: ListItemDto;
    account?: AccountDto;
    equipmentType?: ListItemDto;
    projectedCost?: ProjectedCostDto;
    status?: string | undefined;
    temperatureMax?: string | undefined;
    temperatureMin?: string | undefined;
    tarpsRequired?: boolean;
    oversize?: boolean;
    pickupDate?: DateTime | undefined;
    deliveryDate?: DateTime | undefined;
    referenceNumber?: string | undefined;
    shipperName?: string | undefined;
    receiverName?: string | undefined;
    estimatedPickupHour?: number | undefined;
    estimatedDeliveryHour?: number | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;
    estimatedPickupMinute?: number | undefined;
    estimatedDeliveryMinute?: number | undefined;
    batchId?: number;
    stops?: StopDto[] | undefined;
    leadTimeRange?: string | undefined;
    quoteTargetSellRateDto?: QuoteTargetSellRateDto;
    overriddenQuoteTargetSellRateDto?: QuoteTargetSellRateDto;
    message?: ErrorMessage;
    pricingOverrideDto?: PricingOverrideDto;
    overrideUpdatedBy?: UserDto;
    overrideUpdatedOnUtc?: DateTime | undefined;
    trackingDetails?: QuoteTrackingDto;
    quotePricing?: QuotePricingDto;
    markups?: MarkupDto[] | undefined;
    marketPricing?: MarketPricingDto[] | undefined;
}

export class QuoteStatusRecords implements IQuoteStatusRecords {
    readonly value?: number;
    readonly displayName?: string | undefined;

    constructor(data?: IQuoteStatusRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
            (<any>this).displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): QuoteStatusRecords {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStatusRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IQuoteStatusRecords {
    value?: number;
    displayName?: string | undefined;
}

export class QuoteTargetSellRateDto implements IQuoteTargetSellRateDto {
    markups?: MarkupDto[] | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;
    originalTargetSellRate?: number;
    targetSellRate?: number;
    totalRpm?: number;
    originalTotalRpm?: number;
    totalMarginPercent?: number;
    totalMarginAmount?: number;
    originalTotalMarginPercent?: number;
    originalTotalMarginAmount?: number;
    mileageMinRange?: number;
    mileageMaxRange?: number;
    readonly mileageRange?: string | undefined;
    leadTimeMinHrs?: number;
    leadTimeMaxHrs?: number;

    constructor(data?: IQuoteTargetSellRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["markups"])) {
                this.markups = [] as any;
                for (let item of _data["markups"])
                    this.markups!.push(MarkupDto.fromJS(item));
            }
            this.minimumMarkup = _data["minimumMarkup"];
            this.minimumAmount = _data["minimumAmount"];
            this.originalTargetSellRate = _data["originalTargetSellRate"];
            this.targetSellRate = _data["targetSellRate"];
            this.totalRpm = _data["totalRpm"];
            this.originalTotalRpm = _data["originalTotalRpm"];
            this.totalMarginPercent = _data["totalMarginPercent"];
            this.totalMarginAmount = _data["totalMarginAmount"];
            this.originalTotalMarginPercent = _data["originalTotalMarginPercent"];
            this.originalTotalMarginAmount = _data["originalTotalMarginAmount"];
            this.mileageMinRange = _data["mileageMinRange"];
            this.mileageMaxRange = _data["mileageMaxRange"];
            (<any>this).mileageRange = _data["mileageRange"];
            this.leadTimeMinHrs = _data["leadTimeMinHrs"];
            this.leadTimeMaxHrs = _data["leadTimeMaxHrs"];
        }
    }

    static fromJS(data: any): QuoteTargetSellRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTargetSellRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markups)) {
            data["markups"] = [];
            for (let item of this.markups)
                data["markups"].push(item.toJSON());
        }
        data["minimumMarkup"] = this.minimumMarkup;
        data["minimumAmount"] = this.minimumAmount;
        data["originalTargetSellRate"] = this.originalTargetSellRate;
        data["targetSellRate"] = this.targetSellRate;
        data["totalRpm"] = this.totalRpm;
        data["originalTotalRpm"] = this.originalTotalRpm;
        data["totalMarginPercent"] = this.totalMarginPercent;
        data["totalMarginAmount"] = this.totalMarginAmount;
        data["originalTotalMarginPercent"] = this.originalTotalMarginPercent;
        data["originalTotalMarginAmount"] = this.originalTotalMarginAmount;
        data["mileageMinRange"] = this.mileageMinRange;
        data["mileageMaxRange"] = this.mileageMaxRange;
        data["mileageRange"] = this.mileageRange;
        data["leadTimeMinHrs"] = this.leadTimeMinHrs;
        data["leadTimeMaxHrs"] = this.leadTimeMaxHrs;
        return data;
    }
}

export interface IQuoteTargetSellRateDto {
    markups?: MarkupDto[] | undefined;
    minimumMarkup?: number;
    minimumAmount?: number;
    originalTargetSellRate?: number;
    targetSellRate?: number;
    totalRpm?: number;
    originalTotalRpm?: number;
    totalMarginPercent?: number;
    totalMarginAmount?: number;
    originalTotalMarginPercent?: number;
    originalTotalMarginAmount?: number;
    mileageMinRange?: number;
    mileageMaxRange?: number;
    mileageRange?: string | undefined;
    leadTimeMinHrs?: number;
    leadTimeMaxHrs?: number;
}

export class QuoteTrackingDto implements IQuoteTrackingDto {
    customerContactId?: number;
    customerName?: string | undefined;
    customerPhone?: string | undefined;
    customerEmail?: string | undefined;
    reasonLostId?: number;
    reasonLostText?: string | undefined;
    notes?: string | undefined;
    finalSellRate?: number | undefined;

    constructor(data?: IQuoteTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerContactId = _data["customerContactId"];
            this.customerName = _data["customerName"];
            this.customerPhone = _data["customerPhone"];
            this.customerEmail = _data["customerEmail"];
            this.reasonLostId = _data["reasonLostId"];
            this.reasonLostText = _data["reasonLostText"];
            this.notes = _data["notes"];
            this.finalSellRate = _data["finalSellRate"];
        }
    }

    static fromJS(data: any): QuoteTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerContactId"] = this.customerContactId;
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["customerEmail"] = this.customerEmail;
        data["reasonLostId"] = this.reasonLostId;
        data["reasonLostText"] = this.reasonLostText;
        data["notes"] = this.notes;
        data["finalSellRate"] = this.finalSellRate;
        return data;
    }
}

export interface IQuoteTrackingDto {
    customerContactId?: number;
    customerName?: string | undefined;
    customerPhone?: string | undefined;
    customerEmail?: string | undefined;
    reasonLostId?: number;
    reasonLostText?: string | undefined;
    notes?: string | undefined;
    finalSellRate?: number | undefined;
}

export class Rate implements IRate {
    mileage?: number;
    reports?: number;
    companies?: number;
    standardDeviation?: number;
    perMile?: PerMileTrip;
    perTrip?: PerMileTrip;
    averageFuelSurchargePerTripUsd?: number;

    constructor(data?: IRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mileage = _data["mileage"];
            this.reports = _data["reports"];
            this.companies = _data["companies"];
            this.standardDeviation = _data["standardDeviation"];
            this.perMile = _data["perMile"] ? PerMileTrip.fromJS(_data["perMile"]) : <any>undefined;
            this.perTrip = _data["perTrip"] ? PerMileTrip.fromJS(_data["perTrip"]) : <any>undefined;
            this.averageFuelSurchargePerTripUsd = _data["averageFuelSurchargePerTripUsd"];
        }
    }

    static fromJS(data: any): Rate {
        data = typeof data === 'object' ? data : {};
        let result = new Rate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mileage"] = this.mileage;
        data["reports"] = this.reports;
        data["companies"] = this.companies;
        data["standardDeviation"] = this.standardDeviation;
        data["perMile"] = this.perMile ? this.perMile.toJSON() : <any>undefined;
        data["perTrip"] = this.perTrip ? this.perTrip.toJSON() : <any>undefined;
        data["averageFuelSurchargePerTripUsd"] = this.averageFuelSurchargePerTripUsd;
        return data;
    }
}

export interface IRate {
    mileage?: number;
    reports?: number;
    companies?: number;
    standardDeviation?: number;
    perMile?: PerMileTrip;
    perTrip?: PerMileTrip;
    averageFuelSurchargePerTripUsd?: number;
}

export class RateResponse implements IRateResponse {
    response?: DatRateResponse;
    request?: SocketRequestDatRateModel;

    constructor(data?: IRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"] ? DatRateResponse.fromJS(_data["response"]) : <any>undefined;
            this.request = _data["request"] ? SocketRequestDatRateModel.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRateResponse {
    response?: DatRateResponse;
    request?: SocketRequestDatRateModel;
}

export class RateTimePeriod implements IRateTimePeriod {
    rateTense?: string | undefined;

    constructor(data?: IRateTimePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateTense = _data["rateTense"];
        }
    }

    static fromJS(data: any): RateTimePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new RateTimePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateTense"] = this.rateTense;
        return data;
    }
}

export interface IRateTimePeriod {
    rateTense?: string | undefined;
}

export class Rates implements IRates {
    transaction?: string | undefined;
    created?: DateTime;
    rateResponses?: RateResponse[] | undefined;

    constructor(data?: IRates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction = _data["transaction"];
            this.created = _data["created"] ? DateTime.fromISO(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["rateResponses"])) {
                this.rateResponses = [] as any;
                for (let item of _data["rateResponses"])
                    this.rateResponses!.push(RateResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Rates {
        data = typeof data === 'object' ? data : {};
        let result = new Rates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction;
        data["created"] = this.created ? this.created.toString() : <any>undefined;
        if (Array.isArray(this.rateResponses)) {
            data["rateResponses"] = [];
            for (let item of this.rateResponses)
                data["rateResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRates {
    transaction?: string | undefined;
    created?: DateTime;
    rateResponses?: RateResponse[] | undefined;
}

export class ReasonLostDto implements IReasonLostDto {
    id?: number;
    reason?: string | undefined;
    description?: string | undefined;
    readonly hasFreetext?: boolean;

    constructor(data?: IReasonLostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.description = _data["description"];
            (<any>this).hasFreetext = _data["hasFreetext"];
        }
    }

    static fromJS(data: any): ReasonLostDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonLostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["description"] = this.description;
        data["hasFreetext"] = this.hasFreetext;
        return data;
    }
}

export interface IReasonLostDto {
    id?: number;
    reason?: string | undefined;
    description?: string | undefined;
    hasFreetext?: boolean;
}

export class RequestQuoteOptionsDto implements IRequestQuoteOptionsDto {
    commodities?: ListItemDto[] | undefined;
    specializedServices?: ListItemDto[] | undefined;
    accounts?: ListItemDto[] | undefined;
    equipmentTypes?: EquipmentTypeDto[] | undefined;
    reasonLostOptions?: ReasonLostDto[] | undefined;
    regionFilterOptions?: ListItemDto[] | undefined;
    customMarkupReasons?: string[] | undefined;

    constructor(data?: IRequestQuoteOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["commodities"])) {
                this.commodities = [] as any;
                for (let item of _data["commodities"])
                    this.commodities!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["specializedServices"])) {
                this.specializedServices = [] as any;
                for (let item of _data["specializedServices"])
                    this.specializedServices!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["equipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["equipmentTypes"])
                    this.equipmentTypes!.push(EquipmentTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["reasonLostOptions"])) {
                this.reasonLostOptions = [] as any;
                for (let item of _data["reasonLostOptions"])
                    this.reasonLostOptions!.push(ReasonLostDto.fromJS(item));
            }
            if (Array.isArray(_data["regionFilterOptions"])) {
                this.regionFilterOptions = [] as any;
                for (let item of _data["regionFilterOptions"])
                    this.regionFilterOptions!.push(ListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["customMarkupReasons"])) {
                this.customMarkupReasons = [] as any;
                for (let item of _data["customMarkupReasons"])
                    this.customMarkupReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): RequestQuoteOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestQuoteOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commodities)) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        if (Array.isArray(this.specializedServices)) {
            data["specializedServices"] = [];
            for (let item of this.specializedServices)
                data["specializedServices"].push(item.toJSON());
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        if (Array.isArray(this.equipmentTypes)) {
            data["equipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["equipmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.reasonLostOptions)) {
            data["reasonLostOptions"] = [];
            for (let item of this.reasonLostOptions)
                data["reasonLostOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.regionFilterOptions)) {
            data["regionFilterOptions"] = [];
            for (let item of this.regionFilterOptions)
                data["regionFilterOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.customMarkupReasons)) {
            data["customMarkupReasons"] = [];
            for (let item of this.customMarkupReasons)
                data["customMarkupReasons"].push(item);
        }
        return data;
    }
}

export interface IRequestQuoteOptionsDto {
    commodities?: ListItemDto[] | undefined;
    specializedServices?: ListItemDto[] | undefined;
    accounts?: ListItemDto[] | undefined;
    equipmentTypes?: EquipmentTypeDto[] | undefined;
    reasonLostOptions?: ReasonLostDto[] | undefined;
    regionFilterOptions?: ListItemDto[] | undefined;
    customMarkupReasons?: string[] | undefined;
}

export class RulesEngineConditionModel implements IRulesEngineConditionModel {
    name?: string | undefined;
    value?: string | undefined;
    matchedCondition?: string | undefined;

    constructor(data?: IRulesEngineConditionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.matchedCondition = _data["matchedCondition"];
        }
    }

    static fromJS(data: any): RulesEngineConditionModel {
        data = typeof data === 'object' ? data : {};
        let result = new RulesEngineConditionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["matchedCondition"] = this.matchedCondition;
        return data;
    }
}

export interface IRulesEngineConditionModel {
    name?: string | undefined;
    value?: string | undefined;
    matchedCondition?: string | undefined;
}

export class SettingDto implements ISettingDto {
    settingKey?: string | undefined;
    settingValue?: string | undefined;
    scope?: string | undefined;
    accountId?: number | undefined;
    userId?: number | undefined;
    updatedBy?: UserDto;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["settingKey"];
            this.settingValue = _data["settingValue"];
            this.scope = _data["scope"];
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
            this.updatedBy = _data["updatedBy"] ? UserDto.fromJS(_data["updatedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingKey"] = this.settingKey;
        data["settingValue"] = this.settingValue;
        data["scope"] = this.scope;
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISettingDto {
    settingKey?: string | undefined;
    settingValue?: string | undefined;
    scope?: string | undefined;
    accountId?: number | undefined;
    userId?: number | undefined;
    updatedBy?: UserDto;
}

export class SimilarListInsightsDto implements ISimilarListInsightsDto {
    hashedQuoteId?: string | undefined;
    similarQuotes?: QuoteHistoryDto[] | undefined;
    customerQuotes?: QuoteHistoryDto[] | undefined;
    historicalLoads?: HistoricalLoadDto[] | undefined;
    upcomingLoads?: UpcomingLoadDto[] | undefined;

    constructor(data?: ISimilarListInsightsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashedQuoteId = _data["hashedQuoteId"];
            if (Array.isArray(_data["similarQuotes"])) {
                this.similarQuotes = [] as any;
                for (let item of _data["similarQuotes"])
                    this.similarQuotes!.push(QuoteHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["customerQuotes"])) {
                this.customerQuotes = [] as any;
                for (let item of _data["customerQuotes"])
                    this.customerQuotes!.push(QuoteHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["historicalLoads"])) {
                this.historicalLoads = [] as any;
                for (let item of _data["historicalLoads"])
                    this.historicalLoads!.push(HistoricalLoadDto.fromJS(item));
            }
            if (Array.isArray(_data["upcomingLoads"])) {
                this.upcomingLoads = [] as any;
                for (let item of _data["upcomingLoads"])
                    this.upcomingLoads!.push(UpcomingLoadDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimilarListInsightsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimilarListInsightsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashedQuoteId"] = this.hashedQuoteId;
        if (Array.isArray(this.similarQuotes)) {
            data["similarQuotes"] = [];
            for (let item of this.similarQuotes)
                data["similarQuotes"].push(item.toJSON());
        }
        if (Array.isArray(this.customerQuotes)) {
            data["customerQuotes"] = [];
            for (let item of this.customerQuotes)
                data["customerQuotes"].push(item.toJSON());
        }
        if (Array.isArray(this.historicalLoads)) {
            data["historicalLoads"] = [];
            for (let item of this.historicalLoads)
                data["historicalLoads"].push(item.toJSON());
        }
        if (Array.isArray(this.upcomingLoads)) {
            data["upcomingLoads"] = [];
            for (let item of this.upcomingLoads)
                data["upcomingLoads"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimilarListInsightsDto {
    hashedQuoteId?: string | undefined;
    similarQuotes?: QuoteHistoryDto[] | undefined;
    customerQuotes?: QuoteHistoryDto[] | undefined;
    historicalLoads?: HistoricalLoadDto[] | undefined;
    upcomingLoads?: UpcomingLoadDto[] | undefined;
}

export class SimilarQuoteRequestDto implements ISimilarQuoteRequestDto {
    hashedQuoteId?: string | undefined;
    regionZoneFilter?: number | undefined;
    originFilter?: LocationFilterLevel;
    destinationFilter?: LocationFilterLevel;
    statusFilter?: QuoteStatusRecords;
    filterSameEquipmentType?: boolean;
    similarPickupDateDaysFilter?: number | undefined;
    filterToSameAccount?: boolean;
    paging?: PagingDto;

    constructor(data?: ISimilarQuoteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashedQuoteId = _data["hashedQuoteId"];
            this.regionZoneFilter = _data["regionZoneFilter"];
            this.originFilter = _data["originFilter"];
            this.destinationFilter = _data["destinationFilter"];
            this.statusFilter = _data["statusFilter"] ? QuoteStatusRecords.fromJS(_data["statusFilter"]) : <any>undefined;
            this.filterSameEquipmentType = _data["filterSameEquipmentType"];
            this.similarPickupDateDaysFilter = _data["similarPickupDateDaysFilter"];
            this.filterToSameAccount = _data["filterToSameAccount"];
            this.paging = _data["paging"] ? PagingDto.fromJS(_data["paging"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimilarQuoteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimilarQuoteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashedQuoteId"] = this.hashedQuoteId;
        data["regionZoneFilter"] = this.regionZoneFilter;
        data["originFilter"] = this.originFilter;
        data["destinationFilter"] = this.destinationFilter;
        data["statusFilter"] = this.statusFilter ? this.statusFilter.toJSON() : <any>undefined;
        data["filterSameEquipmentType"] = this.filterSameEquipmentType;
        data["similarPickupDateDaysFilter"] = this.similarPickupDateDaysFilter;
        data["filterToSameAccount"] = this.filterToSameAccount;
        data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISimilarQuoteRequestDto {
    hashedQuoteId?: string | undefined;
    regionZoneFilter?: number | undefined;
    originFilter?: LocationFilterLevel;
    destinationFilter?: LocationFilterLevel;
    statusFilter?: QuoteStatusRecords;
    filterSameEquipmentType?: boolean;
    similarPickupDateDaysFilter?: number | undefined;
    filterToSameAccount?: boolean;
    paging?: PagingDto;
}

export class SocketHistoricalLoadRequestModel implements ISocketHistoricalLoadRequestModel {
    originCountry?: string | undefined;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    destinationCountry?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    extraStops?: ExtraStop[] | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    transportType?: string | undefined;
    region?: string | undefined;
    currency?: string | undefined;

    constructor(data?: ISocketHistoricalLoadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originCountry = _data["originCountry"];
            this.originCity = _data["originCity"];
            this.originState = _data["originState"];
            this.originZip = _data["originZip"];
            this.destinationCountry = _data["destinationCountry"];
            this.destinationCity = _data["destinationCity"];
            this.destinationState = _data["destinationState"];
            this.destinationZip = _data["destinationZip"];
            if (Array.isArray(_data["extraStops"])) {
                this.extraStops = [] as any;
                for (let item of _data["extraStops"])
                    this.extraStops!.push(ExtraStop.fromJS(item));
            }
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.transportType = _data["transportType"];
            this.region = _data["region"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): SocketHistoricalLoadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketHistoricalLoadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originCountry"] = this.originCountry;
        data["originCity"] = this.originCity;
        data["originState"] = this.originState;
        data["originZip"] = this.originZip;
        data["destinationCountry"] = this.destinationCountry;
        data["destinationCity"] = this.destinationCity;
        data["destinationState"] = this.destinationState;
        data["destinationZip"] = this.destinationZip;
        if (Array.isArray(this.extraStops)) {
            data["extraStops"] = [];
            for (let item of this.extraStops)
                data["extraStops"].push(item.toJSON());
        }
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["transportType"] = this.transportType;
        data["region"] = this.region;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ISocketHistoricalLoadRequestModel {
    originCountry?: string | undefined;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    destinationCountry?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    extraStops?: ExtraStop[] | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    transportType?: string | undefined;
    region?: string | undefined;
    currency?: string | undefined;
}

export class SocketHistoricalLoadResponseModel implements ISocketHistoricalLoadResponseModel {
    items?: GreenscreensDataLakeItem[] | undefined;
    outlierItems?: GreenscreensDataLakeItem[] | undefined;

    constructor(data?: ISocketHistoricalLoadResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GreenscreensDataLakeItem.fromJS(item));
            }
            if (Array.isArray(_data["outlierItems"])) {
                this.outlierItems = [] as any;
                for (let item of _data["outlierItems"])
                    this.outlierItems!.push(GreenscreensDataLakeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SocketHistoricalLoadResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketHistoricalLoadResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.outlierItems)) {
            data["outlierItems"] = [];
            for (let item of this.outlierItems)
                data["outlierItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISocketHistoricalLoadResponseModel {
    items?: GreenscreensDataLakeItem[] | undefined;
    outlierItems?: GreenscreensDataLakeItem[] | undefined;
}

export class SocketPricingParametersModel implements ISocketPricingParametersModel {
    quoteID?: string | undefined;
    account?: string | undefined;
    office?: string | undefined;
    team?: string | undefined;
    userName?: string | undefined;
    userRole?: string | undefined;
    isAdmin?: boolean | undefined;
    markups?: MarkupModel[] | undefined;
    originZip?: string | undefined;
    originCity?: string | undefined;
    originState?: string | undefined;
    originLatitude?: number | undefined;
    originLongitude?: number | undefined;
    destinationZip?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destLatitude?: number | undefined;
    destLongitude?: number | undefined;
    equipmentType?: string | undefined;
    reeferMinTemp?: number | undefined;
    reeferMaxTemp?: number | undefined;
    flatbedTarpsRequired?: boolean | undefined;
    flatbedOversized?: boolean | undefined;
    pickupDateUnkown?: boolean;
    pickupDate?: DateTime | undefined;
    pickupHour?: number | undefined;
    pickupDay?: string | undefined;
    deliveryDate?: DateTime | undefined;
    deliveryHour?: number | undefined;
    deliveryDay?: string | undefined;
    commodity?: string | undefined;
    specializedServices?: string[] | undefined;
    shipper?: string | undefined;
    receiver?: string | undefined;
    referenceNumber?: string | undefined;
    region?: string | undefined;
    totalDistance?: number | undefined;
    leadTimeHours?: number | undefined;
    markupPercent?: number | undefined;
    markupMinimumAmount?: number | undefined;
    testQuote?: boolean | undefined;

    constructor(data?: ISocketPricingParametersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteID = _data["quoteID"];
            this.account = _data["account"];
            this.office = _data["office"];
            this.team = _data["team"];
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.isAdmin = _data["isAdmin"];
            if (Array.isArray(_data["markups"])) {
                this.markups = [] as any;
                for (let item of _data["markups"])
                    this.markups!.push(MarkupModel.fromJS(item));
            }
            this.originZip = _data["originZip"];
            this.originCity = _data["originCity"];
            this.originState = _data["originState"];
            this.originLatitude = _data["originLatitude"];
            this.originLongitude = _data["originLongitude"];
            this.destinationZip = _data["destinationZip"];
            this.destinationCity = _data["destinationCity"];
            this.destinationState = _data["destinationState"];
            this.destLatitude = _data["destLatitude"];
            this.destLongitude = _data["destLongitude"];
            this.equipmentType = _data["equipmentType"];
            this.reeferMinTemp = _data["reeferMinTemp"];
            this.reeferMaxTemp = _data["reeferMaxTemp"];
            this.flatbedTarpsRequired = _data["flatbedTarpsRequired"];
            this.flatbedOversized = _data["flatbedOversized"];
            this.pickupDateUnkown = _data["pickupDateUnkown"];
            this.pickupDate = _data["pickupDate"] ? DateTime.fromISO(_data["pickupDate"].toString()) : <any>undefined;
            this.pickupHour = _data["pickupHour"];
            this.pickupDay = _data["pickupDay"];
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryHour = _data["deliveryHour"];
            this.deliveryDay = _data["deliveryDay"];
            this.commodity = _data["commodity"];
            if (Array.isArray(_data["specializedServices"])) {
                this.specializedServices = [] as any;
                for (let item of _data["specializedServices"])
                    this.specializedServices!.push(item);
            }
            this.shipper = _data["shipper"];
            this.receiver = _data["receiver"];
            this.referenceNumber = _data["referenceNumber"];
            this.region = _data["region"];
            this.totalDistance = _data["totalDistance"];
            this.leadTimeHours = _data["leadTimeHours"];
            this.markupPercent = _data["markupPercent"];
            this.markupMinimumAmount = _data["markupMinimumAmount"];
            this.testQuote = _data["testQuote"];
        }
    }

    static fromJS(data: any): SocketPricingParametersModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketPricingParametersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteID"] = this.quoteID;
        data["account"] = this.account;
        data["office"] = this.office;
        data["team"] = this.team;
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["isAdmin"] = this.isAdmin;
        if (Array.isArray(this.markups)) {
            data["markups"] = [];
            for (let item of this.markups)
                data["markups"].push(item.toJSON());
        }
        data["originZip"] = this.originZip;
        data["originCity"] = this.originCity;
        data["originState"] = this.originState;
        data["originLatitude"] = this.originLatitude;
        data["originLongitude"] = this.originLongitude;
        data["destinationZip"] = this.destinationZip;
        data["destinationCity"] = this.destinationCity;
        data["destinationState"] = this.destinationState;
        data["destLatitude"] = this.destLatitude;
        data["destLongitude"] = this.destLongitude;
        data["equipmentType"] = this.equipmentType;
        data["reeferMinTemp"] = this.reeferMinTemp;
        data["reeferMaxTemp"] = this.reeferMaxTemp;
        data["flatbedTarpsRequired"] = this.flatbedTarpsRequired;
        data["flatbedOversized"] = this.flatbedOversized;
        data["pickupDateUnkown"] = this.pickupDateUnkown;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toString() : <any>undefined;
        data["pickupHour"] = this.pickupHour;
        data["pickupDay"] = this.pickupDay;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : <any>undefined;
        data["deliveryHour"] = this.deliveryHour;
        data["deliveryDay"] = this.deliveryDay;
        data["commodity"] = this.commodity;
        if (Array.isArray(this.specializedServices)) {
            data["specializedServices"] = [];
            for (let item of this.specializedServices)
                data["specializedServices"].push(item);
        }
        data["shipper"] = this.shipper;
        data["receiver"] = this.receiver;
        data["referenceNumber"] = this.referenceNumber;
        data["region"] = this.region;
        data["totalDistance"] = this.totalDistance;
        data["leadTimeHours"] = this.leadTimeHours;
        data["markupPercent"] = this.markupPercent;
        data["markupMinimumAmount"] = this.markupMinimumAmount;
        data["testQuote"] = this.testQuote;
        return data;
    }
}

export interface ISocketPricingParametersModel {
    quoteID?: string | undefined;
    account?: string | undefined;
    office?: string | undefined;
    team?: string | undefined;
    userName?: string | undefined;
    userRole?: string | undefined;
    isAdmin?: boolean | undefined;
    markups?: MarkupModel[] | undefined;
    originZip?: string | undefined;
    originCity?: string | undefined;
    originState?: string | undefined;
    originLatitude?: number | undefined;
    originLongitude?: number | undefined;
    destinationZip?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destLatitude?: number | undefined;
    destLongitude?: number | undefined;
    equipmentType?: string | undefined;
    reeferMinTemp?: number | undefined;
    reeferMaxTemp?: number | undefined;
    flatbedTarpsRequired?: boolean | undefined;
    flatbedOversized?: boolean | undefined;
    pickupDateUnkown?: boolean;
    pickupDate?: DateTime | undefined;
    pickupHour?: number | undefined;
    pickupDay?: string | undefined;
    deliveryDate?: DateTime | undefined;
    deliveryHour?: number | undefined;
    deliveryDay?: string | undefined;
    commodity?: string | undefined;
    specializedServices?: string[] | undefined;
    shipper?: string | undefined;
    receiver?: string | undefined;
    referenceNumber?: string | undefined;
    region?: string | undefined;
    totalDistance?: number | undefined;
    leadTimeHours?: number | undefined;
    markupPercent?: number | undefined;
    markupMinimumAmount?: number | undefined;
    testQuote?: boolean | undefined;
}

export class SocketRequestDatRateModel implements ISocketRequestDatRateModel {
    origin?: DatAddressModel;
    destination?: DatAddressModel;
    rateType?: string | undefined;
    equipment?: string | undefined;
    targetEscalation?: TargetEscalation;
    rateTimePeriod?: RateTimePeriod;

    constructor(data?: ISocketRequestDatRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? DatAddressModel.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? DatAddressModel.fromJS(_data["destination"]) : <any>undefined;
            this.rateType = _data["rateType"];
            this.equipment = _data["equipment"];
            this.targetEscalation = _data["targetEscalation"] ? TargetEscalation.fromJS(_data["targetEscalation"]) : <any>undefined;
            this.rateTimePeriod = _data["rateTimePeriod"] ? RateTimePeriod.fromJS(_data["rateTimePeriod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SocketRequestDatRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketRequestDatRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["rateType"] = this.rateType;
        data["equipment"] = this.equipment;
        data["targetEscalation"] = this.targetEscalation ? this.targetEscalation.toJSON() : <any>undefined;
        data["rateTimePeriod"] = this.rateTimePeriod ? this.rateTimePeriod.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISocketRequestDatRateModel {
    origin?: DatAddressModel;
    destination?: DatAddressModel;
    rateType?: string | undefined;
    equipment?: string | undefined;
    targetEscalation?: TargetEscalation;
    rateTimePeriod?: RateTimePeriod;
}

export class SocketResponseDatModel implements ISocketResponseDatModel {
    rates?: Rates;
    loadToTruck?: LoadToTruck[] | undefined;

    constructor(data?: ISocketResponseDatModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rates = _data["rates"] ? Rates.fromJS(_data["rates"]) : <any>undefined;
            if (Array.isArray(_data["loadToTruck"])) {
                this.loadToTruck = [] as any;
                for (let item of _data["loadToTruck"])
                    this.loadToTruck!.push(LoadToTruck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SocketResponseDatModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketResponseDatModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        if (Array.isArray(this.loadToTruck)) {
            data["loadToTruck"] = [];
            for (let item of this.loadToTruck)
                data["loadToTruck"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISocketResponseDatModel {
    rates?: Rates;
    loadToTruck?: LoadToTruck[] | undefined;
}

export class SocketResponseGreenscreensModel implements ISocketResponseGreenscreensModel {
    companyRate?: CompanyNetworkRate;
    networkRate?: CompanyNetworkRate;

    constructor(data?: ISocketResponseGreenscreensModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRate = _data["companyRate"] ? CompanyNetworkRate.fromJS(_data["companyRate"]) : <any>undefined;
            this.networkRate = _data["networkRate"] ? CompanyNetworkRate.fromJS(_data["networkRate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SocketResponseGreenscreensModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketResponseGreenscreensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRate"] = this.companyRate ? this.companyRate.toJSON() : <any>undefined;
        data["networkRate"] = this.networkRate ? this.networkRate.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISocketResponseGreenscreensModel {
    companyRate?: CompanyNetworkRate;
    networkRate?: CompanyNetworkRate;
}

export class SocketResponseModel implements ISocketResponseModel {
    datResponse?: SocketResponseDatModel;
    greenscreensResponse?: SocketResponseGreenscreensModel;
    truckstopResponse?: SocketResponseTruckstopModel;
    pricingPlatform?: SocketPricingParametersModel;

    constructor(data?: ISocketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datResponse = _data["datResponse"] ? SocketResponseDatModel.fromJS(_data["datResponse"]) : <any>undefined;
            this.greenscreensResponse = _data["greenscreensResponse"] ? SocketResponseGreenscreensModel.fromJS(_data["greenscreensResponse"]) : <any>undefined;
            this.truckstopResponse = _data["truckstopResponse"] ? SocketResponseTruckstopModel.fromJS(_data["truckstopResponse"]) : <any>undefined;
            this.pricingPlatform = _data["pricingPlatform"] ? SocketPricingParametersModel.fromJS(_data["pricingPlatform"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SocketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datResponse"] = this.datResponse ? this.datResponse.toJSON() : <any>undefined;
        data["greenscreensResponse"] = this.greenscreensResponse ? this.greenscreensResponse.toJSON() : <any>undefined;
        data["truckstopResponse"] = this.truckstopResponse ? this.truckstopResponse.toJSON() : <any>undefined;
        data["pricingPlatform"] = this.pricingPlatform ? this.pricingPlatform.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISocketResponseModel {
    datResponse?: SocketResponseDatModel;
    greenscreensResponse?: SocketResponseGreenscreensModel;
    truckstopResponse?: SocketResponseTruckstopModel;
    pricingPlatform?: SocketPricingParametersModel;
}

export class SocketResponseTruckstopModel implements ISocketResponseTruckstopModel {
    result?: string | undefined;
    customerLoadId?: string;
    lowerRate?: number;
    predictionRate?: number;
    upperRate?: number;
    message?: string | undefined;
    dataRecordsScore?: number;
    loadInputScore?: number;
    averageScore?: number;
    ratePerMile?: number;

    constructor(data?: ISocketResponseTruckstopModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.customerLoadId = _data["customerLoadId"];
            this.lowerRate = _data["lowerRate"];
            this.predictionRate = _data["predictionRate"];
            this.upperRate = _data["upperRate"];
            this.message = _data["message"];
            this.dataRecordsScore = _data["dataRecordsScore"];
            this.loadInputScore = _data["loadInputScore"];
            this.averageScore = _data["averageScore"];
            this.ratePerMile = _data["ratePerMile"];
        }
    }

    static fromJS(data: any): SocketResponseTruckstopModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocketResponseTruckstopModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["customerLoadId"] = this.customerLoadId;
        data["lowerRate"] = this.lowerRate;
        data["predictionRate"] = this.predictionRate;
        data["upperRate"] = this.upperRate;
        data["message"] = this.message;
        data["dataRecordsScore"] = this.dataRecordsScore;
        data["loadInputScore"] = this.loadInputScore;
        data["averageScore"] = this.averageScore;
        data["ratePerMile"] = this.ratePerMile;
        return data;
    }
}

export interface ISocketResponseTruckstopModel {
    result?: string | undefined;
    customerLoadId?: string;
    lowerRate?: number;
    predictionRate?: number;
    upperRate?: number;
    message?: string | undefined;
    dataRecordsScore?: number;
    loadInputScore?: number;
    averageScore?: number;
    ratePerMile?: number;
}

export class StopDto implements IStopDto {
    order?: number;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    marketArea?: string | undefined;
    pricingRegion?: string | undefined;

    constructor(data?: IStopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.marketArea = _data["marketArea"];
            this.pricingRegion = _data["pricingRegion"];
        }
    }

    static fromJS(data: any): StopDto {
        data = typeof data === 'object' ? data : {};
        let result = new StopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["marketArea"] = this.marketArea;
        data["pricingRegion"] = this.pricingRegion;
        return data;
    }
}

export interface IStopDto {
    order?: number;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    marketArea?: string | undefined;
    pricingRegion?: string | undefined;
}

export class TargetEscalation implements ITargetEscalation {
    escalationType?: string | undefined;
    specificTimeFrame?: string | undefined;

    constructor(data?: ITargetEscalation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.escalationType = _data["escalationType"];
            this.specificTimeFrame = _data["specificTimeFrame"];
        }
    }

    static fromJS(data: any): TargetEscalation {
        data = typeof data === 'object' ? data : {};
        let result = new TargetEscalation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["escalationType"] = this.escalationType;
        data["specificTimeFrame"] = this.specificTimeFrame;
        return data;
    }
}

export interface ITargetEscalation {
    escalationType?: string | undefined;
    specificTimeFrame?: string | undefined;
}

export class TenantDto implements ITenantDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantDto {
    id?: number;
    name?: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class TruckStopProjectedCost implements ITruckStopProjectedCost {
    predictedRate?: number;
    lowRate?: number;
    highRate?: number;

    constructor(data?: ITruckStopProjectedCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predictedRate = _data["predictedRate"];
            this.lowRate = _data["lowRate"];
            this.highRate = _data["highRate"];
        }
    }

    static fromJS(data: any): TruckStopProjectedCost {
        data = typeof data === 'object' ? data : {};
        let result = new TruckStopProjectedCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predictedRate"] = this.predictedRate;
        data["lowRate"] = this.lowRate;
        data["highRate"] = this.highRate;
        return data;
    }
}

export interface ITruckStopProjectedCost {
    predictedRate?: number;
    lowRate?: number;
    highRate?: number;
}

export class UpcomingLoadDto implements IUpcomingLoadDto {
    loadId?: string | undefined;
    loadNumber?: string | undefined;
    buyRate?: number;
    total?: number;
    readonly ratePerMile?: number;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    pickupDate?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    deliveryDate?: string | undefined;
    mileage?: number;
    leadTimeHours?: number | undefined;
    transactionType?: string | undefined;
    covered?: boolean;

    constructor(data?: IUpcomingLoadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadId = _data["loadId"];
            this.loadNumber = _data["loadNumber"];
            this.buyRate = _data["buyRate"];
            this.total = _data["total"];
            (<any>this).ratePerMile = _data["ratePerMile"];
            this.originCity = _data["originCity"];
            this.originState = _data["originState"];
            this.originZip = _data["originZip"];
            this.pickupDate = _data["pickupDate"];
            this.destinationCity = _data["destinationCity"];
            this.destinationState = _data["destinationState"];
            this.destinationZip = _data["destinationZip"];
            this.deliveryDate = _data["deliveryDate"];
            this.mileage = _data["mileage"];
            this.leadTimeHours = _data["leadTimeHours"];
            this.transactionType = _data["transactionType"];
            this.covered = _data["covered"];
        }
    }

    static fromJS(data: any): UpcomingLoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingLoadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadId"] = this.loadId;
        data["loadNumber"] = this.loadNumber;
        data["buyRate"] = this.buyRate;
        data["total"] = this.total;
        data["ratePerMile"] = this.ratePerMile;
        data["originCity"] = this.originCity;
        data["originState"] = this.originState;
        data["originZip"] = this.originZip;
        data["pickupDate"] = this.pickupDate;
        data["destinationCity"] = this.destinationCity;
        data["destinationState"] = this.destinationState;
        data["destinationZip"] = this.destinationZip;
        data["deliveryDate"] = this.deliveryDate;
        data["mileage"] = this.mileage;
        data["leadTimeHours"] = this.leadTimeHours;
        data["transactionType"] = this.transactionType;
        data["covered"] = this.covered;
        return data;
    }
}

export interface IUpcomingLoadDto {
    loadId?: string | undefined;
    loadNumber?: string | undefined;
    buyRate?: number;
    total?: number;
    ratePerMile?: number;
    originCity?: string | undefined;
    originState?: string | undefined;
    originZip?: string | undefined;
    pickupDate?: string | undefined;
    destinationCity?: string | undefined;
    destinationState?: string | undefined;
    destinationZip?: string | undefined;
    deliveryDate?: string | undefined;
    mileage?: number;
    leadTimeHours?: number | undefined;
    transactionType?: string | undefined;
    covered?: boolean;
}

export class UpdateAccountRequestDto implements IUpdateAccountRequestDto {
    id?: number;
    officeId?: number | undefined;
    name?: string | undefined;

    constructor(data?: IUpdateAccountRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.officeId = _data["officeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateAccountRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["officeId"] = this.officeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateAccountRequestDto {
    id?: number;
    officeId?: number | undefined;
    name?: string | undefined;
}

export class UpdateApiUserRequestDto implements IUpdateApiUserRequestDto {
    email!: string;
    firstName!: string;
    lastName!: string;
    id?: number;

    constructor(data?: IUpdateApiUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateApiUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApiUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateApiUserRequestDto {
    email: string;
    firstName: string;
    lastName: string;
    id?: number;
}

export class UpdateCommodityDto implements IUpdateCommodityDto {
    name?: string | undefined;
    id?: number;

    constructor(data?: IUpdateCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateCommodityDto {
    name?: string | undefined;
    id?: number;
}

export class UpdateEquipmentDto implements IUpdateEquipmentDto {
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;
    id?: number;

    constructor(data?: IUpdateEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.hasTemperatureOption = _data["hasTemperatureOption"];
            this.hasTarpOption = _data["hasTarpOption"];
            this.hasOversizedOption = _data["hasOversizedOption"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hasTemperatureOption"] = this.hasTemperatureOption;
        data["hasTarpOption"] = this.hasTarpOption;
        data["hasOversizedOption"] = this.hasOversizedOption;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateEquipmentDto {
    name?: string | undefined;
    hasTemperatureOption?: boolean;
    hasTarpOption?: boolean;
    hasOversizedOption?: boolean;
    id?: number;
}

export class UpdateOfficeRequestDto implements IUpdateOfficeRequestDto {
    id?: number;
    name!: string;
    accountIds?: number[] | undefined;

    constructor(data?: IUpdateOfficeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateOfficeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateOfficeRequestDto {
    id?: number;
    name: string;
    accountIds?: number[] | undefined;
}

export class UpdateQuoteStatusDetailsDto implements IUpdateQuoteStatusDetailsDto {
    hashedId?: string | undefined;
    status?: string | undefined;
    customerName?: string | undefined;
    customerPhone?: string | undefined;
    customerEmail?: string | undefined;
    finalSellRate?: number | undefined;
    finalRpm?: number | undefined;
    lostReason?: number | undefined;
    lostText?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateQuoteStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashedId = _data["hashedId"];
            this.status = _data["status"];
            this.customerName = _data["customerName"];
            this.customerPhone = _data["customerPhone"];
            this.customerEmail = _data["customerEmail"];
            this.finalSellRate = _data["finalSellRate"];
            this.finalRpm = _data["finalRpm"];
            this.lostReason = _data["lostReason"];
            this.lostText = _data["lostText"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateQuoteStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashedId"] = this.hashedId;
        data["status"] = this.status;
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["customerEmail"] = this.customerEmail;
        data["finalSellRate"] = this.finalSellRate;
        data["finalRpm"] = this.finalRpm;
        data["lostReason"] = this.lostReason;
        data["lostText"] = this.lostText;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateQuoteStatusDetailsDto {
    hashedId?: string | undefined;
    status?: string | undefined;
    customerName?: string | undefined;
    customerPhone?: string | undefined;
    customerEmail?: string | undefined;
    finalSellRate?: number | undefined;
    finalRpm?: number | undefined;
    lostReason?: number | undefined;
    lostText?: string | undefined;
    notes?: string | undefined;
}

export class UpdateQuoteStatusRequest implements IUpdateQuoteStatusRequest {
    hashedId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IUpdateQuoteStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashedId = _data["hashedId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateQuoteStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashedId"] = this.hashedId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateQuoteStatusRequest {
    hashedId?: string | undefined;
    status?: string | undefined;
}

export class UpdateSettingDto implements IUpdateSettingDto {
    settingKey?: string | undefined;
    settingValue?: string | undefined;
    scope?: string | undefined;
    accountId?: number | undefined;
    userId?: number | undefined;

    constructor(data?: IUpdateSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["settingKey"];
            this.settingValue = _data["settingValue"];
            this.scope = _data["scope"];
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingKey"] = this.settingKey;
        data["settingValue"] = this.settingValue;
        data["scope"] = this.scope;
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateSettingDto {
    settingKey?: string | undefined;
    settingValue?: string | undefined;
    scope?: string | undefined;
    accountId?: number | undefined;
    userId?: number | undefined;
}

export class UpdateSpecializedServiceDto implements IUpdateSpecializedServiceDto {
    name?: string | undefined;
    id?: number;

    constructor(data?: IUpdateSpecializedServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSpecializedServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecializedServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSpecializedServiceDto {
    name?: string | undefined;
    id?: number;
}

export class UpdateUserRequestDto implements IUpdateUserRequestDto {
    email!: string;
    userRoleId!: number;
    isAdmin?: boolean;
    officeId?: number | undefined;

    constructor(data?: IUpdateUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userRoleId = _data["userRoleId"];
            this.isAdmin = _data["isAdmin"];
            this.officeId = _data["officeId"];
        }
    }

    static fromJS(data: any): UpdateUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userRoleId"] = this.userRoleId;
        data["isAdmin"] = this.isAdmin;
        data["officeId"] = this.officeId;
        return data;
    }
}

export interface IUpdateUserRequestDto {
    email: string;
    userRoleId: number;
    isAdmin?: boolean;
    officeId?: number | undefined;
}

export class UserDto implements IUserDto {
    id?: number;
    email?: string | undefined;
    username?: string | undefined;
    userRole?: string | undefined;
    userRoleId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    office?: OfficeDto;
    apiKey?: string | undefined;
    account?: AccountDto;
    tenant?: TenantDto;
    originalRoleId?: number;
    originalTenantId?: number;
    openQuotes?: QuoteHistoryDto[] | undefined;
    userPermissions?: UserPermissionEnum[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.userRole = _data["userRole"];
            this.userRoleId = _data["userRoleId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAdmin = _data["isAdmin"];
            this.office = _data["office"] ? OfficeDto.fromJS(_data["office"]) : <any>undefined;
            this.apiKey = _data["apiKey"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.originalRoleId = _data["originalRoleId"];
            this.originalTenantId = _data["originalTenantId"];
            if (Array.isArray(_data["openQuotes"])) {
                this.openQuotes = [] as any;
                for (let item of _data["openQuotes"])
                    this.openQuotes!.push(QuoteHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["userRole"] = this.userRole;
        data["userRoleId"] = this.userRoleId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAdmin"] = this.isAdmin;
        data["office"] = this.office ? this.office.toJSON() : <any>undefined;
        data["apiKey"] = this.apiKey;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["originalRoleId"] = this.originalRoleId;
        data["originalTenantId"] = this.originalTenantId;
        if (Array.isArray(this.openQuotes)) {
            data["openQuotes"] = [];
            for (let item of this.openQuotes)
                data["openQuotes"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: number;
    email?: string | undefined;
    username?: string | undefined;
    userRole?: string | undefined;
    userRoleId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    office?: OfficeDto;
    apiKey?: string | undefined;
    account?: AccountDto;
    tenant?: TenantDto;
    originalRoleId?: number;
    originalTenantId?: number;
    openQuotes?: QuoteHistoryDto[] | undefined;
    userPermissions?: UserPermissionEnum[] | undefined;
}

export enum UserPermissionEnum {
    EDIT_BUSINESS_HOURS = "EDIT_BUSINESS_HOURS",
    EDIT_PRICING_PARAMETERS = "EDIT_PRICING_PARAMETERS",
}

export class UserRoleDto implements IUserRoleDto {
    id?: number;
    roleName?: string | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRoleDto {
    id?: number;
    roleName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// noinspection ES6UnusedImports